var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-18",
    d: "M80.67,259.61c-93.52,54-93.52,141.53,0,195.52s245.15,54,338.66,0,93.52-141.53,0-195.52S174.18,205.61,80.67,259.61Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-18",
    cx: 97.4,
    cy: 433.62,
    rx: 55.39,
    ry: 31.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-18",
    cx: 298.57,
    cy: 374.5,
    rx: 55.39,
    ry: 31.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-18",
    d: "M223.58,426.19l2.49-1.62-2.68-1.5-.86-.5-.84-.49a43.09,43.09,0,0,1-5.79-3.73,6.85,6.85,0,0,1,1.73-.41,8,8,0,0,0,3.11-.94,3.45,3.45,0,0,0,1.88-3,4.09,4.09,0,0,0-2.3-3.4,8.42,8.42,0,0,0-4.13-1,6.86,6.86,0,0,0-3.39.82,4.43,4.43,0,0,0-2,2.35,1.7,1.7,0,0,1-1.59.91H209c-2,0-4.66-1.56-8.75-3.93l-2-1.13-.87.45c-8.15,4.2-10.69,6.11-10.86,8.21v.21c0,.86.46,2.85,4.54,3a5.44,5.44,0,0,1,1.45.23,4,4,0,0,1-1,.79,7.43,7.43,0,0,1-3.52,1,2.62,2.62,0,0,1-1.24-.22c-.12-.07-.13-.1-.13-.14a3.7,3.7,0,0,0-3.89-3.2h-.16c-2.56.07-6.4,2.27-12.45,5.85-.39.22-.79.47-1.2.72L166,427.22l3.13,1.76,2.48,1.39a45.86,45.86,0,0,1,5,3,7.41,7.41,0,0,1-1.6.36,8,8,0,0,0-3.12.94,3.46,3.46,0,0,0-1.88,3,4.1,4.1,0,0,0,2.3,3.39,8.4,8.4,0,0,0,4.12,1,6.8,6.8,0,0,0,3.39-.81,4.47,4.47,0,0,0,2-2.35,1.66,1.66,0,0,1,1.58-.91h.16c1.54,0,3.6,1.24,6.45,3,.89.54,1.91,1.16,3,1.8l.85.51.88-.46c9.62-4.95,12.31-6.85,12.48-8.86v-.23c0-.86-.47-2.85-4.55-3a5,5,0,0,1-1.45-.23,4,4,0,0,1,1-.79,7.57,7.57,0,0,1,3.53-1,2.52,2.52,0,0,1,1.24.22.4.4,0,0,1,.12.09,3.72,3.72,0,0,0,3.92,3.25h.13C214.08,432.25,217.78,429.94,223.58,426.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-18",
    d: "M284.39,440a70.08,70.08,0,0,1-9.48-5.47c.24,0,.51-.06.83-.08a6.69,6.69,0,0,0,3.09-.74,3,3,0,0,0,1.59-2.6c0-1.43-1-2.84-2.81-3.88a10.23,10.23,0,0,0-4.92-1.35,5.39,5.39,0,0,0-2.72.63,3.42,3.42,0,0,0-1.76,2.65c0,.17-.34.28-.85.28h0c-2.21-.06-6.34-2.74-11.12-5.84l-1-.62-1,.63c-1,.59-2,1.15-2.8,1.65s-1.39.84-2,1.2c-1.91,1.11-3.34,1.8-4.56,1.8h-.18a1.69,1.69,0,0,1-1.59-.92,4.44,4.44,0,0,0-2-2.33,6.69,6.69,0,0,0-3.38-.82,8.31,8.31,0,0,0-4.13,1.05,4.1,4.1,0,0,0-2.3,3.34,3.47,3.47,0,0,0,1.9,3.08,8.26,8.26,0,0,0,3.09.92,7.09,7.09,0,0,1,1.61.36,46.86,46.86,0,0,1-5,3c-.95.53-1.93,1.07-2.94,1.65l-2.54,1.46,2.46,1.6c6.62,4.28,10.72,6.61,13.44,6.69h.16a3.72,3.72,0,0,0,3.91-3.24.43.43,0,0,1,.11-.09,2.66,2.66,0,0,1,1.24-.22,7.57,7.57,0,0,1,3.53,1,4,4,0,0,1,1,.8,5.51,5.51,0,0,1-1.45.22c-4.23.17-4.55,2.37-4.55,3V449c.19,2.18,2.95,3.95,11.14,8.16l.87.45.84-.49c1-.57,2-1.12,2.95-1.65,4.6-2.55,7.14-4,7.14-6.12a2.45,2.45,0,0,0,0-.39c-.36-2.19-3.11-2.83-4.71-3a5.41,5.41,0,0,1-2-.58,1.14,1.14,0,0,1-.22-.16,2.1,2.1,0,0,1,.57-.45,5.49,5.49,0,0,1,2.65-.63,4.09,4.09,0,0,1,2,.43,1.23,1.23,0,0,1,.59.62,4.73,4.73,0,0,0,4.25,3h.34c2.38,0,4.66-1.36,8.1-3.43.82-.49,1.72-1,2.73-1.61l2.85-1.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-18",
    cx: 419.25,
    cy: 330.36,
    rx: 53.84,
    ry: 31.2,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.91,35.67a1.86,1.86,0,0,0-.08-.41s0-.06,0-.09a1.68,1.68,0,0,0-.11-.4,1.83,1.83,0,0,0-.26-.57.87.87,0,0,0-.15-.24.65.65,0,0,0-.13-.16,1.18,1.18,0,0,0-.3-.29l0,0a1.83,1.83,0,0,0-.38-.23,3.25,3.25,0,0,0-3,.39L43,183c-2.48,1.43-4.5,4.93-4.5,9.94v212.3a3,3,0,0,0,1.62,2.7l.19.13.24.13a1.71,1.71,0,0,0,.38.13,2.25,2.25,0,0,0,.58.08A3,3,0,0,0,43,408l.11-.07h0l4.29-2.48,255-146.92a10,10,0,0,0,4.5-7.79V36.24C306.94,36,306.92,35.85,306.91,35.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,34.32a1.14,1.14,0,0,1,.51.11l.08,0h0l.07.06,0,0,.11.15,0,0v0l.1.14.09.18,0,.06.12.36v0l0,.05,0,.07a.53.53,0,0,1,0,.12c0,.15,0,.3,0,.46V250.75a8.65,8.65,0,0,1-3.86,6.67l-255,146.92-4.17,2.41,0,0-.12.07-.08.05a1.82,1.82,0,0,1-.79.26h-.06a1.42,1.42,0,0,1-.3,0l-.09,0L41,407l-.1-.07-.07,0,0,0-.06,0a1.77,1.77,0,0,1-.94-1.57V403h0V193c0-4.86,2-7.75,3.86-8.82L303.07,34.76a2.86,2.86,0,0,1,1.36-.44m0-1.29a4.06,4.06,0,0,0-2,.61L43,183c-2.48,1.43-4.5,4.93-4.5,9.94V404.28h0v1a3,3,0,0,0,1.62,2.7l.19.13.24.13a1.71,1.71,0,0,0,.38.13,2.25,2.25,0,0,0,.58.08h.06A3,3,0,0,0,43,408l.11-.07h0l4.29-2.48,255-146.92a10,10,0,0,0,4.5-7.79V36.24c0-.2,0-.39,0-.57a1.86,1.86,0,0,0-.08-.41s0-.06,0-.09a1.68,1.68,0,0,0-.11-.4,1.83,1.83,0,0,0-.26-.57.87.87,0,0,0-.15-.24.51.51,0,0,0-.13-.16,1.18,1.18,0,0,0-.3-.29l0,0a1.83,1.83,0,0,0-.38-.23,2.5,2.5,0,0,0-1-.22Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.46,33.25a3.25,3.25,0,0,0-3,.39L43,183a10,10,0,0,0-4.5,7.79v8.72l-5.74-3.36v-8.62a9.9,9.9,0,0,1,4.48-7.77L296.7,30.39a3.11,3.11,0,0,1,3.26-.26C300.77,30.61,304.5,32.75,305.46,33.25Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.93,36.21c0-2.84-2-4-4.5-2.57L43,183a9.93,9.93,0,0,0-4.49,7.78v8.73L306.93,45Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.43,33.64,43,183a9.25,9.25,0,0,0-3.17,3.33l-5.71-3.31a9,9,0,0,1,3.13-3.28L296.69,30.39a3.18,3.18,0,0,1,3.27-.27c.8.5,4.54,2.62,5.48,3.13A3.23,3.23,0,0,0,302.43,33.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.76,196.2v-8.64a9.33,9.33,0,0,1,1.37-4.5l5.73,3.3a9,9,0,0,0-1.35,4.47v8.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4,46.75a4.58,4.58,0,0,0-1.9,3.65c0,1.4.85,2.05,1.9,1.44a4.56,4.56,0,0,0,1.91-3.65C289.31,46.79,288.46,46.14,287.4,46.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.27,42.78a4.57,4.57,0,0,0-1.9,3.64c0,1.41.85,2.06,1.9,1.45a4.56,4.56,0,0,0,1.91-3.65C296.18,42.82,295.33,42.17,294.27,42.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,38.81a4.56,4.56,0,0,0-1.9,3.64c0,1.41.85,2,1.9,1.44a4.54,4.54,0,0,0,1.91-3.64C303.05,38.84,302.2,38.2,301.14,38.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,408l-.23-.13-4.74-2.75a4.78,4.78,0,0,1-2.35-3.48,4.87,4.87,0,0,1,0-.66V196.18l5.75,3.37V405.26a2.93,2.93,0,0,0,1.4,2.55.61.61,0,0,0,.14.1l0,0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,408l-.23-.13-4.74-2.75a4.78,4.78,0,0,1-2.35-3.48,4.87,4.87,0,0,1,0-.66V196.18l5.75,3.37V405.26a2.93,2.93,0,0,0,1.4,2.55.61.61,0,0,0,.14.1l0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228,177.73a.27.27,0,0,1-.17-.06.27.27,0,0,1,0-.37L253,148.21v-4.77a.26.26,0,0,1,.52,0v4.86a.24.24,0,0,1-.06.17l-25.26,29.17A.28.28,0,0,1,228,177.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,175c1.16-.67,2.1-.13,2.1,1.22a4.65,4.65,0,0,1-2.1,3.64c-1.16.67-2.11.13-2.11-1.21A4.67,4.67,0,0,1,228,175Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,155.06a.75.75,0,0,1-.36-.1.71.71,0,0,1-.36-.62V119.71a.71.71,0,0,1,.36-.63L273,96a.71.71,0,0,1,.72,0,.73.73,0,0,1,.36.62v34.63a.71.71,0,0,1-.36.62L233.47,155A.81.81,0,0,1,233.11,155.06Zm.72-34.94v33l38.76-22.26v-33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,282.92H81.4a.27.27,0,0,1-.27-.28v-4.86a.28.28,0,1,1,.55,0v4.58h25a.28.28,0,0,1,.28.28A.27.27,0,0,1,106.66,282.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,280.21a4.66,4.66,0,0,0-2.1,3.65c0,1.34.94,1.88,2.1,1.21a4.63,4.63,0,0,0,2.11-3.64C108.77,280.08,107.83,279.54,106.66,280.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,289.57a.75.75,0,0,1-.38-.1.77.77,0,0,1-.39-.67V236.55a.8.8,0,0,1,.38-.67l40.21-23.33a.78.78,0,0,1,1.16.67v52.24a.77.77,0,0,1-.39.67l-40.2,23.34A.76.76,0,0,1,61.3,289.57ZM62.08,237v50.46L100.73,265V214.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,256.89a.27.27,0,0,1-.17-.06.27.27,0,0,1,0-.37L251,234.89v-8.66a.25.25,0,0,1,.26-.26.26.26,0,0,1,.26.26V235a.28.28,0,0,1-.07.17L232.76,256.8A.25.25,0,0,1,232.56,256.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,254.2c1.17-.67,2.11-.13,2.11,1.22a4.63,4.63,0,0,1-2.11,3.64c-1.16.67-2.1.13-2.1-1.21A4.65,4.65,0,0,1,232.56,254.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,238a.65.65,0,0,1-.36-.1.69.69,0,0,1-.36-.62V202.69a.7.7,0,0,1,.36-.62L271,179a.71.71,0,0,1,.72,0,.73.73,0,0,1,.36.63v34.62a.73.73,0,0,1-.36.63L231.55,238A.8.8,0,0,1,231.19,238Zm.72-34.93v33l38.76-22.26v-33Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flame--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,343l-17.84-4.62L151.32,343s-2.13,9.57.2,24.54,12.77,30,17.65,30,15.31-15,17.65-30S187,343,187,343Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,343l-17.84-4.62L151.32,343s-2.13,9.57.2,24.54,12.77,30,17.65,30,15.31-15,17.65-30S187,343,187,343Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,345.13H156.42c-3.49,21.1,7.72,37.29,12.22,37.29S184.34,366.23,180.85,345.13Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,345.13h4.18a18.49,18.49,0,0,1,2.27,11.27c-.5,5.69-3.94,13.09-6.45,13.09s-5.95-7.4-6.46-13.09a18.49,18.49,0,0,1,2.27-11.27h4.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.63,332.1h0l-2.42-25.81H143.13l-2.42,25.81h0c-.51,4.56,2.23,9.22,8.28,12.7,11.15,6.43,29.21,6.43,40.35,0C195.41,341.32,198.14,336.66,197.63,332.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,318c-10.21-5.88-10.21-15.43,0-21.31s26.73-5.89,36.93,0,10.2,15.43,0,21.31S160.93,323.85,150.73,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,325.78l-.81-8.65c-.75,3.33-3.33,6.55-7.76,9.11-10.66,6.15-27.94,6.15-38.61,0-4.44-2.56-7-5.78-7.77-9.11l-.82,8.65c.66,3.55,3.34,7,8.06,9.73,11,6.32,28.72,6.32,39.67,0C193.74,332.79,196.42,329.34,197.07,325.78Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.68,344.61c.27-.15.54-.31.79-.47h0s-8.45,4.2-21.41,3.65-20.91-5.5-21.15-9.14a46.91,46.91,0,0,1,.55-9c5.06,2.54,12.12,4.25,21.14,4.25,14.53,0,23.35-5,27.33-9.63l-.4-4.3-1.29-13.72H143.13l-2.42,25.81h0a9.22,9.22,0,0,0,.06,2.57,8.3,8.3,0,0,0,.24,1.1,11.72,11.72,0,0,0,.5,1.44c1.21,2.78,3.7,5.42,7.48,7.59,5.57,3.22,12.88,4.83,20.18,4.83a49.49,49.49,0,0,0,5.45-.3c.9-.1,1.79-.23,2.67-.38a36.49,36.49,0,0,0,12.05-4.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,324.15h-.76c-10.67.12-20.17-2.65-26.75-7.84a5.8,5.8,0,1,1,7.19-9.11c4.51,3.56,11.44,5.47,19.48,5.34h.17c8,.09,15-1.78,19.48-5.34a5.8,5.8,0,0,1,7.19,9.11C189.51,321.38,180.3,324.15,169.94,324.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,252.49l-14.36-27-3.79,5.11-6.6,59.34L194.8,293c8.25,4.12,14,13.21,16.22,25.74l4.12,23s1.81-17.18,3.8-37.87C220.71,285.38,220.67,265.21,213.32,252.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,197.21C215,140.43,191,91.37,173.2,80l-.47-.32-.09,0h0a6.85,6.85,0,0,0-6.89,0h0l-.09,0-.47.32c-17.84,11.36-41.83,60.42-41.83,117.2,0,54.63,15.32,103,16.78,107.55,0,.12.07.23.11.34h0c1.11,3.18,3.8,6.21,8.06,8.67,11.54,6.66,30.25,6.66,41.79,0,4.42-2.55,7.14-5.71,8.17-9C199.72,300.25,215,251.84,215,197.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.2,80c11.2,11.1,35.42,55.67,35.42,118.58,0,45.51-9.89,83.52-18.54,115.18,4.26-2.46,6.95-5.49,8.06-8.67h0a3.38,3.38,0,0,0,.11-.34c1.46-4.5,16.78-52.92,16.78-107.55C215,140.43,191,91.37,173.2,80Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.19,79.69a5.91,5.91,0,0,1,2.95.8l0,0,.06,0a3.51,3.51,0,0,1,.4.27h0l0,0c9.17,5.84,19.34,21.2,27.22,41.1A209.54,209.54,0,0,1,214,197.21c0,54.22-15,102-16.73,107.25-1,3.19-3.67,6.11-7.72,8.45-5.44,3.14-12.68,4.87-20.4,4.87s-15-1.73-20.4-4.87c-3.92-2.26-6.55-5.07-7.63-8.13,0-.11-.07-.21-.1-.32-1.71-5.27-16.73-53-16.73-107.25a209.33,209.33,0,0,1,14.16-75.27c7.87-19.9,18-35.26,27.21-41.1l0,0h0a2.9,2.9,0,0,1,.41-.27l0,0,0,0a5.92,5.92,0,0,1,3-.8m0-1a6.82,6.82,0,0,0-3.45.93h0l-.08,0a5.72,5.72,0,0,0-.48.32c-17.84,11.36-41.83,60.42-41.83,117.2,0,54.63,15.32,103,16.78,107.55,0,.12.07.23.11.34h0c1.11,3.18,3.8,6.21,8.06,8.67,5.77,3.33,13.33,5,20.9,5s15.12-1.66,20.89-5c4.42-2.55,7.14-5.71,8.17-9,1.47-4.51,16.78-52.92,16.78-107.55C215,140.43,191,91.37,173.2,80l-.47-.32-.09,0h0a6.81,6.81,0,0,0-3.44-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25,93.65c-4.42-6.33-8.9-11-13.05-13.65-.15-.11-.31-.2-.47-.31l-.09,0h0a6.85,6.85,0,0,0-6.89,0h0l-.09,0-.48.31c-4.14,2.65-8.62,7.32-13,13.66a115.87,115.87,0,0,0-7.64,12.74c.77,2.93,3.11,5.75,7,8,9.77,5.64,25.6,5.64,35.37,0,3.9-2.26,6.26-5.08,7-8A115.11,115.11,0,0,0,186.25,93.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.56,81.47l-2.38-23.23-2.37,23.23h0a1.2,1.2,0,0,0,.7,1,3.73,3.73,0,0,0,3.35,0,1.2,1.2,0,0,0,.7-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.34,197.21c0,54.63,15.32,103,16.78,107.55,0,.12.07.23.11.34h0c1.11,3.18,3.8,6.21,8.06,8.67a33.94,33.94,0,0,0,6.43,2.8c-7.47-26.86-16.24-72.47-16.24-118C138.48,135.68,154,91.11,165.17,80,147.33,91.37,123.34,140.43,123.34,197.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,303.63l11.57-36.87,3.79.74L148.62,313l-6.23,10.31a122.72,122.72,0,0,0-16.23,44.48L122,395.53s-1.81-15.09-3.8-33.49C116.47,345.57,113.35,324.84,120.7,303.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,313,136.06,267.5,124.5,304.36c-7.35,21.21-5.61,42.08-4.4,60.9L122,395.53l4.12-27.77a122.72,122.72,0,0,1,16.23-44.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,157.94c-.91-5.83-3.78-10.28-7.82-12.59l-2.81-1.61A13.53,13.53,0,0,0,189,142a16,16,0,0,0-5.26.91c-8.56,3-14.41,12.72-13.93,23.18.33,7.16,3.74,13.08,8.66,16l3,1.71a13.66,13.66,0,0,0,6.89,1.87,14.41,14.41,0,0,0,4.64-.79C203,181.4,208.05,168.15,206.44,157.94Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.44,157.94c-.91-5.83-3.78-10.28-7.82-12.59l-2.81-1.61A13.53,13.53,0,0,0,189,142a16,16,0,0,0-5.26.91c-8.56,3-14.41,12.72-13.93,23.18.33,7.16,3.74,13.08,8.66,16l3,1.71a13.66,13.66,0,0,0,6.89,1.87,14.41,14.41,0,0,0,4.64-.79C203,181.4,208.05,168.15,206.44,157.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,185.64c-8.5,0-15.27-7.73-15.75-18-.48-10.46,5.38-20.21,13.93-23.18a16,16,0,0,1,5.26-.92c7.53,0,13.28,5.65,14.65,14.38,1.61,10.21-3.41,23.46-13.45,26.91A14.41,14.41,0,0,1,188.35,185.64Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39,180.18c-7.16,2.45-13.45-4.07-13.85-12.75s4.36-16.12,10.61-18.29,12.1,1.18,13.42,9.56S198.55,177.72,191.39,180.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,157.2c-.61-3.87-2.19-6.65-4.33-8.33a10.14,10.14,0,0,0-6.18.27c-6.25,2.17-11,9.62-10.61,18.29.22,4.86,2.3,9,5.33,11.35a8.85,8.85,0,0,0,5.61-.1C195.64,176.22,200,165.59,198.66,157.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,152.72c-5.86,2.93-8.56,9.91-7.44,16.2.09.51.29,1.11.8,1.24s1.06-.47,1.37-1c1.69-3,3.6-6.55,6.72-8.22a11.2,11.2,0,0,1,2.33-.78c2.2-.56,4.12-1.49,4.28-4.06a3.67,3.67,0,0,0-2.89-4.17A7.37,7.37,0,0,0,187.64,152.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,207.26c-.71-4.46-2.9-7.86-6-9.64l-2.14-1.23a10.36,10.36,0,0,0-5.2-1.36,12.23,12.23,0,0,0-4,.71c-6.54,2.27-11,9.73-10.65,17.74.25,5.48,2.86,10,6.63,12.24l2.27,1.31a10.5,10.5,0,0,0,5.27,1.42,10.94,10.94,0,0,0,3.55-.6C201,225.21,204.8,215.07,203.57,207.26Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.57,207.26c-.71-4.46-2.9-7.86-6-9.64l-2.14-1.23a10.36,10.36,0,0,0-5.2-1.36,12.23,12.23,0,0,0-4,.71c-6.54,2.27-11,9.73-10.65,17.74.25,5.48,2.86,10,6.63,12.24l2.27,1.31a10.5,10.5,0,0,0,5.27,1.42,10.94,10.94,0,0,0,3.55-.6C201,225.21,204.8,215.07,203.57,207.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.72,228.45c-6.51,0-11.69-5.91-12.05-13.75-.37-8,4.11-15.47,10.66-17.74a12.11,12.11,0,0,1,4-.7c5.76,0,10.16,4.31,11.22,11,1.23,7.81-2.62,18-10.3,20.59A10.94,10.94,0,0,1,189.72,228.45Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,224.28c-5.47,1.88-10.29-3.12-10.6-9.75s3.35-12.34,8.13-14,9.25.9,10.26,7.31S197.52,222.4,192,224.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.61,206.7a9.77,9.77,0,0,0-3.31-6.38,7.72,7.72,0,0,0-4.73.21c-4.78,1.66-8.44,7.36-8.13,14a11.51,11.51,0,0,0,4.09,8.68,6.72,6.72,0,0,0,4.29-.08C195.29,221.25,198.62,213.11,197.61,206.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,203.26c-4.49,2.24-6.56,7.59-5.7,12.4.07.39.22.86.61,1s.82-.36,1-.77c1.29-2.26,2.76-5,5.15-6.28a7.77,7.77,0,0,1,1.78-.6c1.68-.43,3.15-1.15,3.28-3.11a2.83,2.83,0,0,0-2.22-3.19A5.61,5.61,0,0,0,189.18,203.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.15,78.66h0L91.79,75h0a.74.74,0,0,0-.65,0L86.8,77a1.83,1.83,0,0,1,.13-1l5-10.11a1.13,1.13,0,0,0-.45-1.47l-5.43-3.14h0L79.7,57.57a1.13,1.13,0,0,0-1.49.35L72,67.31a1.87,1.87,0,0,1-.82.63l-.48-4.76a.71.71,0,0,0-.32-.57h0L64,59h0a.71.71,0,0,0-.68.06l-8.45,4.88a2.28,2.28,0,0,0-1,1.58L53,74.87a3.09,3.09,0,0,1-.88,1.75,51.65,51.65,0,0,0-4.69,5,1.62,1.62,0,0,1-1.66.47l-5.42-1.9a1.33,1.33,0,0,0-1.52.57L32.6,91.49a1.33,1.33,0,0,0,.28,1.6l4.35,3.75a1.62,1.62,0,0,1,.42,1.67,50.41,50.41,0,0,0-2,6.55,3.06,3.06,0,0,1-1.08,1.63l-7.71,5.44a2.24,2.24,0,0,0-.86,1.66v9.75a.68.68,0,0,0,.3.63h0l6.36,3.65h0a.7.7,0,0,0,.66,0l4.34-2a1.93,1.93,0,0,1-.13,1.05l-5,10.11a1.14,1.14,0,0,0,.44,1.47l7.64,4.39h0l4.14,2.39a1.15,1.15,0,0,0,1.5-.35l6.24-9.39a1.84,1.84,0,0,1,.83-.63l.47,4.76a.74.74,0,0,0,.33.58h0l6.35,3.64h0a.69.69,0,0,0,.69-.05l8.45-4.88a2.26,2.26,0,0,0,1-1.58l.85-9.4a3.14,3.14,0,0,1,.87-1.75,49.28,49.28,0,0,0,4.69-5,1.63,1.63,0,0,1,1.66-.47l5.43,1.89a1.31,1.31,0,0,0,1.52-.56l6.21-10.76a1.33,1.33,0,0,0-.27-1.6L87.26,106a1.6,1.6,0,0,1-.42-1.67,52,52,0,0,0,2-6.55,3.08,3.08,0,0,1,1.08-1.63l7.72-5.44A2.27,2.27,0,0,0,98.45,89V79.29A.7.7,0,0,0,98.15,78.66Zm-47,32.82c0-9.1,6.39-20.17,14.27-24.72C68.5,85,71.35,84.46,73.68,85c1.21,1.67,1.85,4.22,1.85,7.56,0,9.1-6.38,20.17-14.27,24.72-3.08,1.78-5.7,2.35-7.75,1.87A11.69,11.69,0,0,1,51.15,111.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,78.66h0L91.79,75h0a.74.74,0,0,0-.65,0L86.8,77a1.83,1.83,0,0,1,.13-1l5-10.11a1.13,1.13,0,0,0-.45-1.47l-5.43-3.14h0L79.7,57.57a1.13,1.13,0,0,0-1.49.35L72,67.31a1.87,1.87,0,0,1-.82.63l-.48-4.76a.71.71,0,0,0-.32-.57h0L64,59h0a.71.71,0,0,0-.68.06l-8.45,4.88a2.28,2.28,0,0,0-1,1.58L53,74.87a3.09,3.09,0,0,1-.88,1.75,51.65,51.65,0,0,0-4.69,5,1.62,1.62,0,0,1-1.66.47l-5.42-1.9a1.33,1.33,0,0,0-1.52.57L32.6,91.49a1.33,1.33,0,0,0,.28,1.6l4.35,3.75a1.62,1.62,0,0,1,.42,1.67,50.41,50.41,0,0,0-2,6.55,3.06,3.06,0,0,1-1.08,1.63l-7.71,5.44a2.24,2.24,0,0,0-.86,1.66v9.75a.68.68,0,0,0,.3.63h0l6.36,3.65h0a.7.7,0,0,0,.66,0l4.34-2a1.93,1.93,0,0,1-.13,1.05l-5,10.11a1.14,1.14,0,0,0,.44,1.47l7.64,4.39h0l4.14,2.39a1.15,1.15,0,0,0,1.5-.35l6.24-9.39a1.84,1.84,0,0,1,.83-.63l.47,4.76a.74.74,0,0,0,.33.58h0l6.35,3.64h0a.69.69,0,0,0,.69-.05l8.45-4.88a2.26,2.26,0,0,0,1-1.58l.85-9.4a3.14,3.14,0,0,1,.87-1.75,49.28,49.28,0,0,0,4.69-5,1.63,1.63,0,0,1,1.66-.47l5.43,1.89a1.31,1.31,0,0,0,1.52-.56l6.21-10.76a1.33,1.33,0,0,0-.27-1.6L87.26,106a1.6,1.6,0,0,1-.42-1.67,52,52,0,0,0,2-6.55,3.08,3.08,0,0,1,1.08-1.63l7.72-5.44A2.27,2.27,0,0,0,98.45,89V79.29A.7.7,0,0,0,98.15,78.66Zm-47,32.82c0-9.1,6.39-20.17,14.27-24.72C68.5,85,71.35,84.46,73.68,85c1.21,1.67,1.85,4.22,1.85,7.56,0,9.1-6.38,20.17-14.27,24.72-3.08,1.78-5.7,2.35-7.75,1.87A11.69,11.69,0,0,1,51.15,111.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.12,125a.89.89,0,0,0-1.25-.59l-3.17,1.43a1.87,1.87,0,0,1-.14,1.06l-5,10.11a1.14,1.14,0,0,0,.44,1.47l7.64,4.39-1.29-.75a1.13,1.13,0,0,1-.44-1.47l5-10.1a2,2,0,0,0-.12-1.82A17.43,17.43,0,0,1,42.12,125Zm18.31,18.84a.92.92,0,0,1-.26-.54l-.82-8.21a.89.89,0,0,0-1.13-.79,17.63,17.63,0,0,1-4.07.41,2,2,0,0,0-.81.17l.48,4.77a.7.7,0,0,0,.33.57h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.68,95c0,9.1-6.38,20.16-14.26,24.72-5,2.87-9.37,2.46-11.92-.54,2,.5,4.68-.08,7.77-1.86,7.88-4.55,14.26-15.62,14.26-24.72,0-3.33-.64-5.88-1.84-7.57C77.32,85.92,79.68,89.46,79.68,95Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,57.56a1.13,1.13,0,0,0-1.49.36L72,67.31a1.61,1.61,0,0,1-.42.4l6.36,3.66a1.53,1.53,0,0,0,.42-.42l6.24-9.39a1.15,1.15,0,0,1,1.37-.41ZM91.79,75h0a.73.73,0,0,0-.66,0l-4.34,2a2.07,2.07,0,0,0,.26.76,17,17,0,0,1,1.6,3.55.75.75,0,0,1,.07.18,1.07,1.07,0,0,0,.22.39l.11.1a.85.85,0,0,0,.25.13.79.79,0,0,0,.46,0,.56.56,0,0,0,.21-.06l7.52-3.39.19-.07a.58.58,0,0,1,.26,0,.49.49,0,0,1,.21.08h0ZM64,59a.69.69,0,0,0-.68.07l-8.45,4.87a2.2,2.2,0,0,0-.84,1l6.34,3.65a2.16,2.16,0,0,1,.85-1l8.45-4.89a.76.76,0,0,1,.64-.08ZM35.21,106.06a2.76,2.76,0,0,1-.59.63l-7.72,5.43a2.11,2.11,0,0,0-.51.59l6.34,3.64a1.73,1.73,0,0,1,.52-.58L41,110.34a2.77,2.77,0,0,0,.59-.63Zm4.69-26a1.36,1.36,0,0,0-1.09.63L32.6,91.48a1.35,1.35,0,0,0-.14.79l6.35,3.66a1.29,1.29,0,0,1,.14-.8l6.22-10.76a1.29,1.29,0,0,1,1-.62Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,57.56a1.13,1.13,0,0,0-1.49.36L72,67.31a1.61,1.61,0,0,1-.42.4l6.36,3.66a1.53,1.53,0,0,0,.42-.42l6.24-9.39a1.15,1.15,0,0,1,1.37-.41ZM91.79,75h0a.73.73,0,0,0-.66,0l-4.34,2a2.07,2.07,0,0,0,.26.76,17,17,0,0,1,1.6,3.55.75.75,0,0,1,.07.18,1.07,1.07,0,0,0,.22.39l.11.1a.85.85,0,0,0,.25.13.79.79,0,0,0,.46,0,.56.56,0,0,0,.21-.06l7.52-3.39.19-.07a.58.58,0,0,1,.26,0,.49.49,0,0,1,.21.08h0ZM64,59a.69.69,0,0,0-.68.07l-8.45,4.87a2.2,2.2,0,0,0-.84,1l6.34,3.65a2.16,2.16,0,0,1,.85-1l8.45-4.89a.76.76,0,0,1,.64-.08ZM35.21,106.06a2.76,2.76,0,0,1-.59.63l-7.72,5.43a2.11,2.11,0,0,0-.51.59l6.34,3.64a1.73,1.73,0,0,1,.52-.58L41,110.34a2.77,2.77,0,0,0,.59-.63Zm4.69-26a1.36,1.36,0,0,0-1.09.63L32.6,91.48a1.35,1.35,0,0,0-.14.79l6.35,3.66a1.29,1.29,0,0,1,.14-.8l6.22-10.76a1.29,1.29,0,0,1,1-.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,89V79.29a.63.63,0,0,0-1-.62L90,82.06a.89.89,0,0,1-1.25-.58A16.76,16.76,0,0,0,87,77.75a2.08,2.08,0,0,1-.11-1.82l5-10.11a1.13,1.13,0,0,0-.45-1.47l-5.43-3.14a1.15,1.15,0,0,0-1.5.35L78.31,71a2.08,2.08,0,0,1-1.63.82,16.69,16.69,0,0,0-4.07.41.9.9,0,0,1-1.13-.8l-.82-8.2a.63.63,0,0,0-1-.52l-8.45,4.87a2.28,2.28,0,0,0-1,1.58l-.85,9.4a3.09,3.09,0,0,1-.88,1.75,52.85,52.85,0,0,0-4.69,5,1.62,1.62,0,0,1-1.66.47l-5.42-1.89a1.32,1.32,0,0,0-1.52.56L39,95.13a1.33,1.33,0,0,0,.27,1.6l4.35,3.75a1.62,1.62,0,0,1,.42,1.67,50.81,50.81,0,0,0-2,6.55A3.21,3.21,0,0,1,41,110.34l-7.72,5.43a2.25,2.25,0,0,0-.86,1.66v9.75a.63.63,0,0,0,1,.62l7.52-3.38a.89.89,0,0,1,1.25.58,17.13,17.13,0,0,0,1.67,3.72,2.07,2.07,0,0,1,.12,1.83l-5,10.1a1.14,1.14,0,0,0,.44,1.47l5.44,3.14a1.15,1.15,0,0,0,1.5-.35l6.24-9.39a2.06,2.06,0,0,1,1.64-.81,16.59,16.59,0,0,0,4.06-.42.9.9,0,0,1,1.13.8l.83,8.2a.63.63,0,0,0,1,.53l8.45-4.88a2.26,2.26,0,0,0,1-1.58l.85-9.4a3.14,3.14,0,0,1,.87-1.75,49.28,49.28,0,0,0,4.69-5,1.63,1.63,0,0,1,1.66-.47l5.43,1.89a1.31,1.31,0,0,0,1.52-.56l6.21-10.76a1.33,1.33,0,0,0-.27-1.6L87.26,106a1.6,1.6,0,0,1-.42-1.67,52,52,0,0,0,2-6.55,3.12,3.12,0,0,1,1.08-1.63l7.72-5.44A2.27,2.27,0,0,0,98.45,89Zm-33,30.67c-7.88,4.55-14.27.87-14.27-8.23s6.39-20.17,14.27-24.72S79.69,85.9,79.69,95,73.3,115.16,65.42,119.71Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,89V79.29a.63.63,0,0,0-1-.62L90,82.06a.89.89,0,0,1-1.25-.58A16.76,16.76,0,0,0,87,77.75a2.08,2.08,0,0,1-.11-1.82l5-10.11a1.13,1.13,0,0,0-.45-1.47l-5.43-3.14a1.15,1.15,0,0,0-1.5.35L78.31,71a2.08,2.08,0,0,1-1.63.82,16.69,16.69,0,0,0-4.07.41.9.9,0,0,1-1.13-.8l-.82-8.2a.63.63,0,0,0-1-.52l-8.45,4.87a2.28,2.28,0,0,0-1,1.58l-.85,9.4a3.09,3.09,0,0,1-.88,1.75,52.85,52.85,0,0,0-4.69,5,1.62,1.62,0,0,1-1.66.47l-5.42-1.89a1.32,1.32,0,0,0-1.52.56L39,95.13a1.33,1.33,0,0,0,.27,1.6l4.35,3.75a1.62,1.62,0,0,1,.42,1.67,50.81,50.81,0,0,0-2,6.55A3.21,3.21,0,0,1,41,110.34l-7.72,5.43a2.25,2.25,0,0,0-.86,1.66v9.75a.63.63,0,0,0,1,.62l7.52-3.38a.89.89,0,0,1,1.25.58,17.13,17.13,0,0,0,1.67,3.72,2.07,2.07,0,0,1,.12,1.83l-5,10.1a1.14,1.14,0,0,0,.44,1.47l5.44,3.14a1.15,1.15,0,0,0,1.5-.35l6.24-9.39a2.06,2.06,0,0,1,1.64-.81,16.59,16.59,0,0,0,4.06-.42.9.9,0,0,1,1.13.8l.83,8.2a.63.63,0,0,0,1,.53l8.45-4.88a2.26,2.26,0,0,0,1-1.58l.85-9.4a3.14,3.14,0,0,1,.87-1.75,49.28,49.28,0,0,0,4.69-5,1.63,1.63,0,0,1,1.66-.47l5.43,1.89a1.31,1.31,0,0,0,1.52-.56l6.21-10.76a1.33,1.33,0,0,0-.27-1.6L87.26,106a1.6,1.6,0,0,1-.42-1.67,52,52,0,0,0,2-6.55,3.12,3.12,0,0,1,1.08-1.63l7.72-5.44A2.27,2.27,0,0,0,98.45,89Zm-33,30.67c-7.88,4.55-14.27.87-14.27-8.23s6.39-20.17,14.27-24.72S79.69,85.9,79.69,95,73.3,115.16,65.42,119.71Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5,61.78a.46.46,0,0,1,.2,0L91.14,65a.43.43,0,0,1,.16.53l-5,10.11a2.75,2.75,0,0,0,.14,2.51A16.35,16.35,0,0,1,88,81.69a1.62,1.62,0,0,0,1.54,1.17,1.65,1.65,0,0,0,.69-.15l7.47-3.37V89a1.6,1.6,0,0,1-.55,1.08l-7.72,5.43a3.88,3.88,0,0,0-1.37,2.07,49,49,0,0,1-1.93,6.45,2.35,2.35,0,0,0,.63,2.47l4.35,3.74a.63.63,0,0,1,.12.71l-6.21,10.75a.61.61,0,0,1-.51.27l-.16,0L79,120.1a1.89,1.89,0,0,0-.67-.12,2.34,2.34,0,0,0-1.78.81,50.31,50.31,0,0,1-4.62,4.89,3.84,3.84,0,0,0-1.11,2.22l-.84,9.4a1.6,1.6,0,0,1-.66,1l-8.4,4.85L60.06,135a1.59,1.59,0,0,0-1.6-1.47,2.58,2.58,0,0,0-.39,0,16.18,16.18,0,0,1-3.52.4h-.43a2.8,2.8,0,0,0-2.19,1.13l-6.25,9.39a.42.42,0,0,1-.35.18.41.41,0,0,1-.19-.05L39.7,141.5a.42.42,0,0,1-.16-.53l5-10.11a2.79,2.79,0,0,0-.14-2.51,15.51,15.51,0,0,1-1.61-3.57,1.61,1.61,0,0,0-1.54-1.17,1.72,1.72,0,0,0-.69.15l-7.47,3.37v-9.7a1.59,1.59,0,0,1,.56-1.08l7.72-5.43a3.82,3.82,0,0,0,1.36-2.06,51.88,51.88,0,0,1,1.93-6.46,2.32,2.32,0,0,0-.62-2.46L39.7,96.19a.61.61,0,0,1-.12-.7l6.21-10.76a.6.6,0,0,1,.51-.27l.15,0,5.42,1.9a2.15,2.15,0,0,0,.68.11,2.36,2.36,0,0,0,1.77-.8A50.52,50.52,0,0,1,59,80.79a3.82,3.82,0,0,0,1.1-2.22l.85-9.4a1.61,1.61,0,0,1,.65-1L70,63.3l.82,8.16a1.59,1.59,0,0,0,1.61,1.46,1.72,1.72,0,0,0,.39,0,16.11,16.11,0,0,1,3.52-.4h.43a2.79,2.79,0,0,0,2.19-1.13L85.16,62a.4.4,0,0,1,.34-.18h0M59,122.38a13.58,13.58,0,0,0,6.74-2c8.06-4.65,14.62-16,14.62-25.33a12.65,12.65,0,0,0-2.34-8,7.75,7.75,0,0,0-6.27-3,13.55,13.55,0,0,0-6.73,2c-8.07,4.66-14.63,16-14.63,25.34,0,6.62,3.38,10.9,8.61,10.9M85.5,61.07a1.13,1.13,0,0,0-.94.49L78.31,71a2.06,2.06,0,0,1-1.59.82h-.43a17.1,17.1,0,0,0-3.68.42.93.93,0,0,1-.23,0,.88.88,0,0,1-.9-.82l-.82-8.2c0-.41-.28-.65-.6-.65a.82.82,0,0,0-.42.13l-8.45,4.87a2.28,2.28,0,0,0-1,1.58l-.85,9.4a3.09,3.09,0,0,1-.88,1.75,52.85,52.85,0,0,0-4.69,5,1.62,1.62,0,0,1-1.22.54,1.31,1.31,0,0,1-.44-.07l-5.42-1.89a1.07,1.07,0,0,0-.39-.07,1.32,1.32,0,0,0-1.13.63L39,95.13a1.33,1.33,0,0,0,.27,1.6l4.35,3.75a1.62,1.62,0,0,1,.42,1.67,50.81,50.81,0,0,0-2,6.55A3.21,3.21,0,0,1,41,110.34l-7.72,5.43a2.25,2.25,0,0,0-.86,1.66v9.75c0,.44.24.71.59.71a.87.87,0,0,0,.37-.09l7.52-3.38a.92.92,0,0,1,.39-.09.9.9,0,0,1,.86.67,17.13,17.13,0,0,0,1.67,3.72,2.07,2.07,0,0,1,.12,1.83l-5,10.1a1.14,1.14,0,0,0,.44,1.47l5.44,3.14a1.08,1.08,0,0,0,.55.15,1.15,1.15,0,0,0,1-.5l6.24-9.39a2.08,2.08,0,0,1,1.6-.81h.43a17.09,17.09,0,0,0,3.67-.42l.24,0a.88.88,0,0,1,.89.82l.83,8.2c0,.41.28.65.59.65a.87.87,0,0,0,.42-.12l8.45-4.88a2.26,2.26,0,0,0,1-1.58l.85-9.4a3.14,3.14,0,0,1,.87-1.75,49.28,49.28,0,0,0,4.69-5,1.68,1.68,0,0,1,1.23-.54,1.21,1.21,0,0,1,.43.07l5.43,1.89a1,1,0,0,0,.39.07,1.33,1.33,0,0,0,1.13-.63l6.21-10.76a1.33,1.33,0,0,0-.27-1.6L87.26,106a1.62,1.62,0,0,1-.43-1.67,50.41,50.41,0,0,0,2-6.55,3.12,3.12,0,0,1,1.08-1.63l7.72-5.44A2.27,2.27,0,0,0,98.45,89V79.29c0-.44-.25-.71-.6-.71a.87.87,0,0,0-.36.09L90,82.06a1,1,0,0,1-.4.09.91.91,0,0,1-.85-.67A16.76,16.76,0,0,0,87,77.75a2.08,2.08,0,0,1-.11-1.82l5-10.11a1.13,1.13,0,0,0-.45-1.47l-5.43-3.14a1.14,1.14,0,0,0-.56-.14ZM59,121.66c-4.68,0-7.89-3.73-7.89-10.18,0-9.1,6.39-20.17,14.27-24.72a13,13,0,0,1,6.37-2c4.68,0,7.9,3.73,7.9,10.19,0,9.1-6.39,20.16-14.27,24.71a12.88,12.88,0,0,1-6.38,2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.62,54.19a3.84,3.84,0,0,1,1-2.06l4.16-3.82a2.55,2.55,0,0,0,.7-2.05l-.78-4.54a.89.89,0,0,0-.4-.63h0l-4.93-2.84h0a.79.79,0,0,0-.86.08l-1.79,1.17,1.73-4.67a1,1,0,0,0-.48-1.29h0l-4.94-2.85h0a1.62,1.62,0,0,0-.33-.13l-3.13-.7a1.7,1.7,0,0,0-1.78.82l-2.94,5.62a3,3,0,0,1-1.18,1.09l-.13-.45a.91.91,0,0,0-.4-.55h0l-4.95-2.86h0a.79.79,0,0,0-.92.12l-4.7,3.7a2.65,2.65,0,0,0-.89,2l.28,4.47a3.52,3.52,0,0,1-.73,2.16c-.77.92-1.5,1.89-2.18,2.89a2.45,2.45,0,0,1-1.91,1l-3-.15a1.94,1.94,0,0,0-1.74,1.06l-2.84,6.37a1.2,1.2,0,0,0,.49,1.52h0l3.34,1.93a1.45,1.45,0,0,1,.08.87,27.85,27.85,0,0,0-.52,3,3.87,3.87,0,0,1-1,2.07l-4.16,3.82a2.55,2.55,0,0,0-.7,2l.78,4.54a.85.85,0,0,0,.38.61h0l5,2.86h0a.79.79,0,0,0,.85-.09l1.79-1.18-1.73,4.68a1,1,0,0,0,.41,1.27h0l5,2.86h0a1.09,1.09,0,0,0,.35.15l3.13.71a1.71,1.71,0,0,0,1.78-.83l3-5.61a2.82,2.82,0,0,1,1.17-1.09l.13.45a.89.89,0,0,0,.41.55h0l4.91,2.83h0l0,0h0a.8.8,0,0,0,.9-.14l4.7-3.69a2.65,2.65,0,0,0,.89-2l-.28-4.47a3.52,3.52,0,0,1,.73-2.16c.77-.92,1.5-1.89,2.18-2.89a2.45,2.45,0,0,1,1.91-1l3,.15a2,2,0,0,0,1.74-1.06L154,61.56a1.22,1.22,0,0,0-.64-1.61l-2.44-1a1.52,1.52,0,0,1-.83-1.68A27.61,27.61,0,0,0,150.62,54.19ZM125.56,68c-.93-5.35,2.45-12.93,7.55-16.93a10.29,10.29,0,0,1,5.35-2.39,8.2,8.2,0,0,1,.58,2c.93,5.35-2.45,12.93-7.54,16.93A10.32,10.32,0,0,1,126.16,70,7.27,7.27,0,0,1,125.56,68Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,54.19a3.84,3.84,0,0,1,1-2.06l4.16-3.82a2.55,2.55,0,0,0,.7-2.05l-.78-4.54a.89.89,0,0,0-.4-.63h0l-4.93-2.84h0a.79.79,0,0,0-.86.08l-1.79,1.17,1.73-4.67a1,1,0,0,0-.48-1.29h0l-4.94-2.85h0a1.62,1.62,0,0,0-.33-.13l-3.13-.7a1.7,1.7,0,0,0-1.78.82l-2.94,5.62a3,3,0,0,1-1.18,1.09l-.13-.45a.91.91,0,0,0-.4-.55h0l-4.95-2.86h0a.79.79,0,0,0-.92.12l-4.7,3.7a2.65,2.65,0,0,0-.89,2l.28,4.47a3.52,3.52,0,0,1-.73,2.16c-.77.92-1.5,1.89-2.18,2.89a2.45,2.45,0,0,1-1.91,1l-3-.15a1.94,1.94,0,0,0-1.74,1.06l-2.84,6.37a1.2,1.2,0,0,0,.49,1.52h0l3.34,1.93a1.45,1.45,0,0,1,.08.87,27.85,27.85,0,0,0-.52,3,3.87,3.87,0,0,1-1,2.07l-4.16,3.82a2.55,2.55,0,0,0-.7,2l.78,4.54a.85.85,0,0,0,.38.61h0l5,2.86h0a.79.79,0,0,0,.85-.09l1.79-1.18-1.73,4.68a1,1,0,0,0,.41,1.27h0l5,2.86h0a1.09,1.09,0,0,0,.35.15l3.13.71a1.71,1.71,0,0,0,1.78-.83l3-5.61a2.82,2.82,0,0,1,1.17-1.09l.13.45a.89.89,0,0,0,.41.55h0l4.91,2.83h0l0,0h0a.8.8,0,0,0,.9-.14l4.7-3.69a2.65,2.65,0,0,0,.89-2l-.28-4.47a3.52,3.52,0,0,1,.73-2.16c.77-.92,1.5-1.89,2.18-2.89a2.45,2.45,0,0,1,1.91-1l3,.15a2,2,0,0,0,1.74-1.06L154,61.56a1.22,1.22,0,0,0-.64-1.61l-2.44-1a1.52,1.52,0,0,1-.83-1.68A27.61,27.61,0,0,0,150.62,54.19ZM125.56,68c-.93-5.35,2.45-12.93,7.55-16.93a10.29,10.29,0,0,1,5.35-2.39,8.2,8.2,0,0,1,.58,2c.93,5.35-2.45,12.93-7.54,16.93A10.32,10.32,0,0,1,126.16,70,7.27,7.27,0,0,1,125.56,68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89,78a1.2,1.2,0,0,0-1.66-.38l-2.38,1.57-1.72,4.67a1,1,0,0,0,.41,1.27l4.9,2.82a1,1,0,0,1-.37-1.24L122.19,81a2.08,2.08,0,0,0-.48-2A9,9,0,0,1,120.89,78Zm14.46,7.16a.92.92,0,0,1-.4-.54l-1-3.52a1.08,1.08,0,0,0-1.49-.68,14.06,14.06,0,0,1-1.93.64,2.54,2.54,0,0,0-.61.25l.14.45a.93.93,0,0,0,.41.55h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,70.44c-4.39,3.45-8.62,3.12-10.28-.48a10.18,10.18,0,0,0,5.33-2.37c5.09-4,8.48-11.58,7.56-16.93a7.55,7.55,0,0,0-.6-2c2.8-.24,5,1.43,5.54,4.81C144.91,58.86,141.53,66.43,136.44,70.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,49.64a2,2,0,0,1-.86.18l-3-.14a1.89,1.89,0,0,0-1.25.45l5,2.86a1.88,1.88,0,0,1,1.25-.46l3,.15a2.11,2.11,0,0,0,.87-.17Zm10.19-16.12a.81.81,0,0,0-.92.13l-4.7,3.7a2.59,2.59,0,0,0-.78,1.23l5,2.85a2.5,2.5,0,0,1,.77-1.23l4.7-3.69a.79.79,0,0,1,.93-.12h0ZM112.91,66.58l-4.11,3.78a2.47,2.47,0,0,0-.64,1.18l4.94,2.85a2.43,2.43,0,0,1,.65-1.18l4.11-3.77Zm31.17-35.9a1.07,1.07,0,0,0-.33-.12l-3.13-.71a1.71,1.71,0,0,0-1.78.82l-2.94,5.62a2.61,2.61,0,0,1-.67.75l4.94,2.86a2.78,2.78,0,0,0,.67-.76l2.95-5.62a1.7,1.7,0,0,1,1.77-.82l3.13.71a2,2,0,0,1,.32.11Zm6.31,7.56h0a.8.8,0,0,0-.86.07l-1.79,1.19-.39,1.05a2.07,2.07,0,0,0,.49,2,8.92,8.92,0,0,1,.81,1,1.21,1.21,0,0,0,.21.24l.18.14a1,1,0,0,0,.42.16,1.14,1.14,0,0,0,.55,0,.75.75,0,0,0,.3-.14l4.16-2.74a2,2,0,0,1,.31-.14.61.61,0,0,1,.35,0,.66.66,0,0,1,.2.06Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,49.64a2,2,0,0,1-.86.18l-3-.14a1.89,1.89,0,0,0-1.25.45l5,2.86a1.88,1.88,0,0,1,1.25-.46l3,.15a2.11,2.11,0,0,0,.87-.17Zm10.19-16.12a.81.81,0,0,0-.92.13l-4.7,3.7a2.59,2.59,0,0,0-.78,1.23l5,2.85a2.5,2.5,0,0,1,.77-1.23l4.7-3.69a.79.79,0,0,1,.93-.12h0ZM112.91,66.58l-4.11,3.78a2.47,2.47,0,0,0-.64,1.18l4.94,2.85a2.43,2.43,0,0,1,.65-1.18l4.11-3.77Zm31.17-35.9a1.07,1.07,0,0,0-.33-.12l-3.13-.71a1.71,1.71,0,0,0-1.78.82l-2.94,5.62a2.61,2.61,0,0,1-.67.75l4.94,2.86a2.78,2.78,0,0,0,.67-.76l2.95-5.62a1.7,1.7,0,0,1,1.77-.82l3.13.71a2,2,0,0,1,.32.11Zm6.31,7.56h0a.8.8,0,0,0-.86.07l-1.79,1.19-.39,1.05a2.07,2.07,0,0,0,.49,2,8.92,8.92,0,0,1,.81,1,1.21,1.21,0,0,0,.21.24l.18.14a1,1,0,0,0,.42.16,1.14,1.14,0,0,0,.55,0,.75.75,0,0,0,.3-.14l4.16-2.74a2,2,0,0,1,.31-.14.61.61,0,0,1,.35,0,.66.66,0,0,1,.2.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,46.26l-.78-4.54a.75.75,0,0,0-1.24-.54l-4.16,2.74a1.21,1.21,0,0,1-1.67-.38,7.92,7.92,0,0,0-.81-1,2.05,2.05,0,0,1-.49-2l2.12-5.74a1,1,0,0,0-.77-1.42l-3.14-.71a1.69,1.69,0,0,0-1.77.83l-2.95,5.61a3.08,3.08,0,0,1-1.78,1.34,15.56,15.56,0,0,0-1.93.64,1.06,1.06,0,0,1-1.48-.68l-1.06-3.51a.78.78,0,0,0-1.33-.42l-4.7,3.69a2.65,2.65,0,0,0-.89,2l.28,4.47a3.46,3.46,0,0,1-.73,2.16c-.77.92-1.5,1.89-2.18,2.89a2.44,2.44,0,0,1-1.91,1l-3-.15a1.93,1.93,0,0,0-1.73,1.06L115.54,60a1.2,1.2,0,0,0,.63,1.61l2.44,1a1.51,1.51,0,0,1,.84,1.68,27.67,27.67,0,0,0-.53,3,3.76,3.76,0,0,1-1,2.06l-4.17,3.82a2.52,2.52,0,0,0-.69,2.05l.78,4.54a.75.75,0,0,0,1.24.54l4.16-2.74a1.21,1.21,0,0,1,1.67.38,7.92,7.92,0,0,0,.81,1,2.07,2.07,0,0,1,.48,2l-2.12,5.74a1,1,0,0,0,.78,1.42l3.13.71a1.71,1.71,0,0,0,1.78-.83l3-5.61A3,3,0,0,1,130.49,81a14.52,14.52,0,0,0,1.93-.64,1.07,1.07,0,0,1,1.48.68L135,84.59a.78.78,0,0,0,1.32.42l4.7-3.69a2.65,2.65,0,0,0,.89-2l-.28-4.47a3.58,3.58,0,0,1,.73-2.16c.77-.92,1.5-1.89,2.18-2.89a2.45,2.45,0,0,1,1.91-1l3,.15a2,2,0,0,0,1.74-1.06L154,61.56a1.22,1.22,0,0,0-.64-1.61l-2.44-1a1.52,1.52,0,0,1-.83-1.68,27.61,27.61,0,0,0,.52-3,3.84,3.84,0,0,1,1-2.06l4.16-3.82A2.55,2.55,0,0,0,156.5,46.26ZM136.44,70.44c-5.09,4-10,2.91-10.88-2.43s2.45-12.93,7.55-16.93,10-2.91,10.88,2.43S141.53,66.44,136.44,70.44Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,46.26l-.78-4.54a.75.75,0,0,0-1.24-.54l-4.16,2.74a1.21,1.21,0,0,1-1.67-.38,7.92,7.92,0,0,0-.81-1,2.05,2.05,0,0,1-.49-2l2.12-5.74a1,1,0,0,0-.77-1.42l-3.14-.71a1.69,1.69,0,0,0-1.77.83l-2.95,5.61a3.08,3.08,0,0,1-1.78,1.34,15.56,15.56,0,0,0-1.93.64,1.06,1.06,0,0,1-1.48-.68l-1.06-3.51a.78.78,0,0,0-1.33-.42l-4.7,3.69a2.65,2.65,0,0,0-.89,2l.28,4.47a3.46,3.46,0,0,1-.73,2.16c-.77.92-1.5,1.89-2.18,2.89a2.44,2.44,0,0,1-1.91,1l-3-.15a1.93,1.93,0,0,0-1.73,1.06L115.54,60a1.2,1.2,0,0,0,.63,1.61l2.44,1a1.51,1.51,0,0,1,.84,1.68,27.67,27.67,0,0,0-.53,3,3.76,3.76,0,0,1-1,2.06l-4.17,3.82a2.52,2.52,0,0,0-.69,2.05l.78,4.54a.75.75,0,0,0,1.24.54l4.16-2.74a1.21,1.21,0,0,1,1.67.38,7.92,7.92,0,0,0,.81,1,2.07,2.07,0,0,1,.48,2l-2.12,5.74a1,1,0,0,0,.78,1.42l3.13.71a1.71,1.71,0,0,0,1.78-.83l3-5.61A3,3,0,0,1,130.49,81a14.52,14.52,0,0,0,1.93-.64,1.07,1.07,0,0,1,1.48.68L135,84.59a.78.78,0,0,0,1.32.42l4.7-3.69a2.65,2.65,0,0,0,.89-2l-.28-4.47a3.58,3.58,0,0,1,.73-2.16c.77-.92,1.5-1.89,2.18-2.89a2.45,2.45,0,0,1,1.91-1l3,.15a2,2,0,0,0,1.74-1.06L154,61.56a1.22,1.22,0,0,0-.64-1.61l-2.44-1a1.52,1.52,0,0,1-.83-1.68,27.61,27.61,0,0,0,.52-3,3.84,3.84,0,0,1,1-2.06l4.16-3.82A2.55,2.55,0,0,0,156.5,46.26ZM136.44,70.44c-5.09,4-10,2.91-10.88-2.43s2.45-12.93,7.55-16.93,10-2.91,10.88,2.43S141.53,66.44,136.44,70.44Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.26,33.42h0l.14,0,3.13.7a.33.33,0,0,1,.23.15.31.31,0,0,1,0,.28l-2.12,5.74a2.79,2.79,0,0,0,.65,2.75A9.46,9.46,0,0,1,148,44a2,2,0,0,0,1.65.89,1.87,1.87,0,0,0,1-.32l4.16-2.73.07,0a.25.25,0,0,0,0,.07l.78,4.54a1.84,1.84,0,0,1-.47,1.38l-4.16,3.82a4.58,4.58,0,0,0-1.25,2.53,26.83,26.83,0,0,1-.51,3,2.27,2.27,0,0,0,1.27,2.54l2.44,1a.43.43,0,0,1,.25.26.45.45,0,0,1,0,.36l-2.84,6.36a1.2,1.2,0,0,1-1,.62h0l-3-.15h-.11a3.21,3.21,0,0,0-2.46,1.3c-.67,1-1.39,1.94-2.13,2.83a4.29,4.29,0,0,0-.91,2.69l.28,4.46a1.87,1.87,0,0,1-.6,1.36l-4.7,3.69-.09.07a.27.27,0,0,1-.06-.11l-1.06-3.52a1.77,1.77,0,0,0-1.73-1.3,2,2,0,0,0-.75.15,13.47,13.47,0,0,1-1.83.6A3.83,3.83,0,0,0,128,82l-2.94,5.61a1,1,0,0,1-.81.46l-.15,0-3.13-.7a.3.3,0,0,1-.23-.15.38.38,0,0,1,0-.28l2.13-5.74a2.82,2.82,0,0,0-.65-2.75,8.16,8.16,0,0,1-.74-.91,2,2,0,0,0-1.65-.89,1.9,1.9,0,0,0-1,.32l-4.15,2.73-.07,0a.14.14,0,0,1,0-.07l-.79-4.54a1.8,1.8,0,0,1,.47-1.37l4.16-3.83a4.52,4.52,0,0,0,1.26-2.53,26.83,26.83,0,0,1,.51-3,2.27,2.27,0,0,0-1.28-2.54l-2.44-1a.49.49,0,0,1-.25-.26.5.5,0,0,1,0-.36l2.84-6.36a1.21,1.21,0,0,1,1-.62h0l3,.15h.11a3.2,3.2,0,0,0,2.46-1.3c.67-1,1.39-1.94,2.14-2.83a4.34,4.34,0,0,0,.9-2.69l-.28-4.46a1.9,1.9,0,0,1,.61-1.36l4.69-3.69.1-.07a.61.61,0,0,1,.05.11l1.06,3.52a1.79,1.79,0,0,0,1.73,1.3,2,2,0,0,0,.75-.15,13.93,13.93,0,0,1,1.83-.6,3.8,3.8,0,0,0,2.26-1.72l2.95-5.61a1,1,0,0,1,.81-.46M130.59,73.6A10.53,10.53,0,0,0,136.9,71c5.28-4.15,8.79-12.06,7.83-17.64C144.14,50,142,47.92,139,47.92a10.55,10.55,0,0,0-6.31,2.57c-5.27,4.15-8.78,12.06-7.82,17.64.59,3.43,2.74,5.47,5.77,5.47m14.67-40.93a1.72,1.72,0,0,0-1.47.86l-2.95,5.61a3.08,3.08,0,0,1-1.78,1.34,14.06,14.06,0,0,0-1.93.64,1.35,1.35,0,0,1-.47.09,1,1,0,0,1-1-.77l-1.06-3.51a.81.81,0,0,0-.75-.65,1,1,0,0,0-.58.23l-4.69,3.69a2.62,2.62,0,0,0-.9,2l.28,4.47a3.46,3.46,0,0,1-.73,2.16c-.77.92-1.5,1.89-2.18,2.89a2.45,2.45,0,0,1-1.84,1h-.07l-3-.15H120a1.94,1.94,0,0,0-1.66,1.06L115.54,60a1.2,1.2,0,0,0,.63,1.61l2.44,1a1.51,1.51,0,0,1,.84,1.68,27.67,27.67,0,0,0-.53,3,3.76,3.76,0,0,1-1,2.06l-4.16,3.82a2.49,2.49,0,0,0-.7,2.05l.78,4.54c.08.46.36.72.71.72a1,1,0,0,0,.53-.18l4.16-2.74a1.13,1.13,0,0,1,.63-.19,1.29,1.29,0,0,1,1,.57,7.92,7.92,0,0,0,.81,1,2.07,2.07,0,0,1,.48,2l-2.12,5.74a1,1,0,0,0,.78,1.42l3.13.71a1.55,1.55,0,0,0,.31,0,1.71,1.71,0,0,0,1.47-.86l3-5.61A3,3,0,0,1,130.49,81a14.52,14.52,0,0,0,1.93-.64,1.25,1.25,0,0,1,.46-.09,1,1,0,0,1,1,.77L135,84.59a.79.79,0,0,0,.74.65.9.9,0,0,0,.58-.23l4.7-3.69a2.65,2.65,0,0,0,.89-2l-.28-4.47a3.58,3.58,0,0,1,.73-2.16c.77-.92,1.5-1.89,2.18-2.89a2.45,2.45,0,0,1,1.84-1h.07l3,.15h.07a2,2,0,0,0,1.67-1.06L154,61.56a1.22,1.22,0,0,0-.64-1.61l-2.44-1a1.52,1.52,0,0,1-.83-1.68,27.61,27.61,0,0,0,.52-3,3.84,3.84,0,0,1,1-2.06l4.16-3.82a2.55,2.55,0,0,0,.7-2.05l-.78-4.54c-.08-.46-.36-.72-.72-.72a1,1,0,0,0-.52.18l-4.16,2.74a1.16,1.16,0,0,1-.63.19,1.28,1.28,0,0,1-1-.57,7.92,7.92,0,0,0-.81-1,2.08,2.08,0,0,1-.49-2l2.12-5.74a1,1,0,0,0-.77-1.42l-3.14-.71a1.53,1.53,0,0,0-.3,0ZM130.59,72.85c-2.55,0-4.49-1.67-5-4.84-.92-5.35,2.46-12.93,7.56-16.93A9.76,9.76,0,0,1,139,48.67c2.55,0,4.49,1.67,5,4.84.92,5.35-2.46,12.93-7.55,16.93a9.78,9.78,0,0,1-5.85,2.41Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-4--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.9,441.77c-9.39,0-18.78-2.06-25.93-6.19s-10.89-9.47-10.89-15.25S370,409.13,377,405.08c14.3-8.26,37.57-8.26,51.88,0h0c7,4.05,10.88,9.47,10.88,15.25s-3.87,11.2-10.89,15.25S412.3,441.77,402.9,441.77Zm0-41.95c-9.23,0-18.45,2-25.47,6.08-6.72,3.88-10.41,9-10.41,14.43s3.69,10.56,10.41,14.43c14,8.11,36.89,8.11,50.93,0,6.72-3.87,10.41-9,10.41-14.43s-3.69-10.55-10.41-14.43h0C421.35,401.85,412.13,399.82,402.91,399.82Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.88,412.66v6.12l-6-16.42v-6.11h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.88 412.66 403.88 418.78 428.8 410.13 428.8 404.02 403.88 412.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.84,396.25l6,16.41L428.8,404C422,398.05,410.07,395.07,397.84,396.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,413.8a1.09,1.09,0,0,0,0,.18v-.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,420.38l-3.7,17.4c-15.11-1.47-26-9.11-25.89-17.84h0v-6c0,8.67,10.88,16.23,25.9,17.69l2.54-12Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,420.38l-3.7,17.4c-15.11-1.47-26-9.11-25.89-17.84h0v-6c0,8.67,10.88,16.23,25.9,17.69l2.54-12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.53,431.87V438a48.26,48.26,0,0,0,18.39-2.52c7.12-2.47,12.15-6.39,14.16-11.05a11.07,11.07,0,0,0,.94-4.26v-6.32a6.52,6.52,0,0,1-3.75-2.29l-4.67,1.62-21.37,7.41Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.53,431.87V438a48.26,48.26,0,0,0,18.39-2.52c7.12-2.47,12.15-6.39,14.16-11.05a11.07,11.07,0,0,0,.94-4.26v-6.32a6.52,6.52,0,0,1-3.75-2.29l-4.67,1.62-21.37,7.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.94 406.81 400.5 417.53 400.5 411.41 381.94 400.7 381.94 406.81",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.94 406.81 400.5 417.53 400.5 411.41 381.94 400.7 381.94 406.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,411.78c-2,9.55,9.39,18.3,25.67,19.89l3.7-17.4-21.48-12.41C375.43,404.67,372.85,407.92,372,411.78Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,411.78c-2,9.55,9.39,18.3,25.67,19.89l3.7-17.4-21.48-12.41C375.43,404.67,372.85,407.92,372,411.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,431.36l-.11.51a48.26,48.26,0,0,0,18.39-2.51c7.12-2.47,12.15-6.4,14.16-11.05,1.89-4.39.89-8.93-2.81-12.88l-4.67,1.62-21.37,7.42Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,431.36l-.11.51a48.26,48.26,0,0,0,18.39-2.51c7.12-2.47,12.15-6.4,14.16-11.05,1.89-4.39.89-8.93-2.81-12.88l-4.67,1.62-21.37,7.42Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,400.7l18.56,10.71L395,396.59A38,38,0,0,0,381.94,400.7Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.4 420.38 401.4 414.26 397.69 431.67 397.69 437.78 401.4 420.38",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.4 420.38 401.4 414.26 397.69 431.67 397.69 437.78 401.4 420.38",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.08 387.08 421.03 389.41 425.08 391.75 429.12 389.41 425.08 387.08",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.08 387.08 421.03 389.41 425.08 391.75 429.12 389.41 425.08 387.08",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.12 389.41 429.12 391.75 425.08 394.09 425.08 391.75 429.12 389.41",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.12 389.41 429.12 391.75 425.08 394.09 425.08 391.75 429.12 389.41",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.08 391.75 425.08 394.09 421.03 391.75 421.03 389.41 425.08 391.75",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.08 391.75 425.08 394.09 421.03 391.75 421.03 389.41 425.08 391.75",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,385.27l12.7-7.33a3.45,3.45,0,0,1,3.14-.06c.84.48.79,1.29-.1,1.81L434.29,387a3.48,3.48,0,0,1-3.14.06C430.31,386.59,430.36,385.78,431.25,385.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.19 392.34 430.14 394.67 434.19 397.01 438.23 394.67 434.19 392.34",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.19 392.34 430.14 394.67 434.19 397.01 438.23 394.67 434.19 392.34",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.23 394.67 438.23 397.01 434.19 399.35 434.19 397.01 438.23 394.67",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.23 394.67 438.23 397.01 434.19 399.35 434.19 397.01 438.23 394.67",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.19 397.01 434.19 399.35 430.14 397.01 430.14 394.67 434.19 397.01",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.19 397.01 434.19 399.35 430.14 397.01 430.14 394.67 434.19 397.01",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.36,390.53l12.7-7.33a3.45,3.45,0,0,1,3.14-.06c.84.48.8,1.29-.1,1.81l-12.7,7.33a3.48,3.48,0,0,1-3.14.06C439.42,391.85,439.47,391,440.36,390.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 397.6 439.26 399.93 443.3 402.27 447.34 399.93 443.3 397.6",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 397.6 439.26 399.93 443.3 402.27 447.34 399.93 443.3 397.6",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.35 399.93 447.35 402.27 443.3 404.61 443.3 402.27 447.35 399.93",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 402.27 443.3 404.61 439.26 402.27 439.26 399.93 443.3 402.27",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 402.27 443.3 404.61 439.26 402.27 439.26 399.93 443.3 402.27",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.47,395.79l12.71-7.33a3.43,3.43,0,0,1,3.13-.06c.84.48.8,1.29-.1,1.81l-12.7,7.33a3.48,3.48,0,0,1-3.14.06C448.54,397.11,448.58,396.3,449.47,395.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.41 402.86 448.37 405.19 452.41 407.53 456.45 405.19 452.41 402.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.46 405.19 456.45 407.53 452.41 409.87 452.41 407.53 456.46 405.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.41 407.53 452.41 409.87 448.37 407.53 448.37 405.19 452.41 407.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.59,401.05l12.7-7.33a3.43,3.43,0,0,1,3.13-.06c.84.48.8,1.29-.1,1.81l-12.7,7.33a3.46,3.46,0,0,1-3.13.06C457.65,402.37,457.69,401.56,458.59,401.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.13,152.28l60.59-35c1-.56,1.78-.1,1.78,1v83.31a4,4,0,0,1-1.78,3.09l-60.59,35c-1,.57-1.78.11-1.78-1V155.37A4,4,0,0,1,293.13,152.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.19,125.48,298,156.15a4.33,4.33,0,0,0-2,3.4v79.86a4.3,4.3,0,0,0,2,3.38l3.73,2.12a4.37,4.37,0,0,0,3.94,0l53.17-30.67a4.32,4.32,0,0,0,2-3.4V131a4.28,4.28,0,0,0-2-3.38l-3.74-2.12A4.35,4.35,0,0,0,351.19,125.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,244.89a4.47,4.47,0,0,1-3.94,0L298,242.79a4.28,4.28,0,0,1-2-3.38V159.55a4.08,4.08,0,0,1,.63-2l7.64,4.42a4,4,0,0,0-.58,1.94v79.85C303.74,244.9,304.55,245.56,305.7,244.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.81,130.6c-.16-1-1-1.34-1.94-.78L305.71,160.5a3.91,3.91,0,0,0-1.39,1.46l-7.65-4.42a3.76,3.76,0,0,1,1.35-1.39l53.17-30.68a4.42,4.42,0,0,1,3.93,0l3.74,2.12A4.36,4.36,0,0,1,360.81,130.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,129.83,305.7,160.5a4.33,4.33,0,0,0-2,3.4v79.86c0,1.25.88,1.76,2,1.13l53.17-30.67a4.31,4.31,0,0,0,2-3.4V131C360.83,129.71,360,129.2,358.87,129.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,131.41v79.41a2.82,2.82,0,0,1-1.17,2L305.31,243.3V163.9a2.8,2.8,0,0,1,1.18-2l52.77-30.45m.49-1.85a1.74,1.74,0,0,0-.88.27L305.7,160.5a4.33,4.33,0,0,0-2,3.4v79.86c0,.89.44,1.4,1.08,1.4a1.78,1.78,0,0,0,.88-.27l53.17-30.67a4.31,4.31,0,0,0,2-3.4V131c0-.89-.44-1.4-1.08-1.4Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Controls--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.72,211l.13-65c0-1.22-.8-1.74-1.78-1.17a4.08,4.08,0,0,0-1.79,3.23l-.13,65.06c0,1.21.8,1.74,1.79,1.17A4.11,4.11,0,0,0,347.72,211Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,193V211a4.11,4.11,0,0,1-1.78,3.24c-1,.57-1.79,0-1.79-1.17l0-18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8,201.36a4.39,4.39,0,0,1-1.66.59v-6.86l3.58-2.06v6.72A8,8,0,0,1,345.8,201.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.46,191.44c0-2.89-2-4.07-4.54-2.62a10,10,0,0,0-4.54,7.86c0,2.9,2,4.07,4.54,2.62A10,10,0,0,0,350.46,191.44Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.46,191.44c0-2.89-2-4.07-4.54-2.62a10,10,0,0,0-4.54,7.86c0,2.9,2,4.07,4.54,2.62A10,10,0,0,0,350.46,191.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09,218.85l.13-65c0-1.22-.8-1.74-1.79-1.17a4.1,4.1,0,0,0-1.78,3.23l-.13,65.06c0,1.21.8,1.74,1.78,1.17A4.09,4.09,0,0,0,334.09,218.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.16,171l-.07,47.86a4.09,4.09,0,0,1-1.79,3.24c-1,.57-1.78,0-1.78-1.17l.06-47.86Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,179.09a4.41,4.41,0,0,1-1.68.59v-6.62l3.58-2.07v6.51A8,8,0,0,1,332.25,179.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,169.17c0-2.89-2-4.06-4.54-2.62a10,10,0,0,0-4.54,7.87c0,2.89,2,4.07,4.54,2.62A10,10,0,0,0,336.91,169.17Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,169.17c0-2.89-2-4.06-4.54-2.62a10,10,0,0,0-4.54,7.87c0,2.89,2,4.07,4.54,2.62A10,10,0,0,0,336.91,169.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.46,226.72l.13-65.05c0-1.22-.8-1.74-1.79-1.17a4.08,4.08,0,0,0-1.79,3.23l-.13,65.06c0,1.21.8,1.74,1.79,1.17A4.09,4.09,0,0,0,320.46,226.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.44,208.77l0,17.95a4.09,4.09,0,0,1-1.79,3.24c-1,.57-1.79,0-1.79-1.17v-18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.54,217.1a4.37,4.37,0,0,1-1.67.59v-6.86l3.57-2.06v6.72A8.18,8.18,0,0,1,318.54,217.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,207.18c0-2.9-2-4.07-4.54-2.62a10,10,0,0,0-4.54,7.86c0,2.9,2,4.07,4.54,2.62A10,10,0,0,0,323.2,207.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,207.18c0-2.9-2-4.07-4.54-2.62a10,10,0,0,0-4.54,7.86c0,2.9,2,4.07,4.54,2.62A10,10,0,0,0,323.2,207.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.13,70.41l60.59-35c1-.57,1.78-.11,1.78,1V89.2a4,4,0,0,1-1.78,3.08l-60.59,35c-1,.57-1.78.11-1.78-1V73.49A3.93,3.93,0,0,1,293.13,70.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.19,43.6,298,74.27a4.36,4.36,0,0,0-2,3.4V127a4.3,4.3,0,0,0,2,3.38l3.73,2.12a4.44,4.44,0,0,0,3.94,0l53.17-30.67a4.34,4.34,0,0,0,2-3.4V49.08a4.3,4.3,0,0,0-2-3.38l-3.74-2.12A4.38,4.38,0,0,0,351.19,43.6Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,132.44a4.5,4.5,0,0,1-3.94,0L298,130.33a4.25,4.25,0,0,1-2-3.37V77.67a4,4,0,0,1,.63-2l7.64,4.42a3.92,3.92,0,0,0-.58,1.93V131.3C303.74,132.45,304.55,133.11,305.7,132.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.81,48.73c-.16-1-1-1.35-1.94-.78L305.71,78.62a3.94,3.94,0,0,0-1.39,1.47l-7.65-4.42a3.87,3.87,0,0,1,1.35-1.4L351.19,43.6a4.35,4.35,0,0,1,3.93,0l3.74,2.12A4.34,4.34,0,0,1,360.81,48.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,48,305.7,78.62a4.36,4.36,0,0,0-2,3.4v49.29c0,1.25.88,1.75,2,1.13l53.17-30.67a4.33,4.33,0,0,0,2-3.4V49.08C360.83,47.83,360,47.32,358.87,48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,49.54V98.37a2.83,2.83,0,0,1-1.17,2l-52.78,30.44V82a2.8,2.8,0,0,1,1.18-2l52.77-30.44m.49-1.86a1.84,1.84,0,0,0-.88.27L305.7,78.62a4.36,4.36,0,0,0-2,3.4v49.29c0,.88.44,1.4,1.08,1.4a1.78,1.78,0,0,0,.88-.27l53.17-30.67a4.33,4.33,0,0,0,2-3.4V49.08c0-.88-.44-1.4-1.08-1.4Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 100.81 346.3 66.65 343.25 64.89 343.25 99.06 346.3 100.81",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 100.81 346.3 66.65 343.25 64.89 343.25 99.06 346.3 100.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 100.81 355.15 95.71 355.15 61.55 346.3 66.65 346.3 100.81",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.15 61.55 352.1 59.78 343.25 64.89 346.3 66.65 355.15 61.55",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.15 61.55 352.1 59.78 343.25 64.89 346.3 66.65 355.15 61.55",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,61.55l-8.85,5-3.05-1.63,2.93,2c-.07,1,0,33,.12,34,.13-1,.19-33,.12-34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 110.39 329.71 82.95 326.66 81.19 326.66 108.63 329.71 110.39",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 110.39 329.71 82.95 326.66 81.19 326.66 108.63 329.71 110.39",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 110.39 338.56 105.28 338.56 77.84 329.71 82.95 329.71 110.39",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 110.39 338.56 105.28 338.56 77.84 329.71 82.95 329.71 110.39",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.56 77.84 335.51 76.08 326.66 81.19 329.71 82.95 338.56 77.84",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.56 77.84 335.51 76.08 326.66 81.19 329.71 82.95 338.56 77.84",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.83,83l8.73-5.17-8.85,5c-1-.54-3-1.63-3-1.63s1.95,1.25,2.93,1.83c0,1,.05,26.32.12,27.37C329.78,109.34,329.86,84,329.83,83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.12 119.97 313.12 96.94 310.07 95.18 310.07 118.21 313.12 119.97",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.12 119.97 313.12 96.94 310.07 95.18 310.07 118.21 313.12 119.97",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.12 119.97 321.97 114.86 321.97 91.83 313.12 96.94 313.12 119.97",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.12 119.97 321.97 114.86 321.97 91.83 313.12 96.94 313.12 119.97",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.97 91.83 318.92 90.07 310.07 95.18 313.12 96.94 321.97 91.83",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.97 91.83 318.92 90.07 310.07 95.18 313.12 96.94 321.97 91.83",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,91.83l-8.85,5-3.05-1.62L313,97.09s0,22.25.12,22.88c.14-.63.13-22.88.13-22.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.1,40.27V28.94c0-.08,0-.29-.19-.29a.35.35,0,0,0-.2.07L192.28,47.44a1.28,1.28,0,0,0-.57,1V79.5c0,.09,0,.3.19.3a.4.4,0,0,0,.21-.07L224.53,61a1.28,1.28,0,0,0,.57-1V40.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9,80.13c-.26,0-.52-.19-.52-.63V48.43a1.6,1.6,0,0,1,.74-1.28l32.42-18.72c.41-.23.89-.12.89.51V60a1.61,1.61,0,0,1-.73,1.28L192.27,80A.78.78,0,0,1,191.9,80.13Zm32.88-51.07L192.45,47.72a1,1,0,0,0-.41.71v31l32.33-18.66a1,1,0,0,0,.41-.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,72.31c-.1.06-.18,0-.18-.17V49.44a.46.46,0,0,1,.18-.38c.11-.06.19,0,.19.17v22.7A.46.46,0,0,1,197,72.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,58.65,194.84,73.56c-.1.06-.19,0-.19-.17a.46.46,0,0,1,.19-.38L220.66,58.1c.1-.06.18,0,.18.17A.46.46,0,0,1,220.66,58.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.46 51.1 198.29 52.94 198.29 68.87 201.46 67.04 201.46 51.1",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.46 51.1 198.29 52.94 198.29 68.87 201.46 67.04 201.46 51.1",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.97 59.56 202.79 61.39 202.79 66.27 205.97 64.44 205.97 59.56",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.47 54.39 207.3 56.22 207.3 63.67 210.47 61.84 210.47 54.39",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.47 54.39 207.3 56.22 207.3 63.67 210.47 61.84 210.47 54.39",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.97 42.41 211.8 44.24 211.8 61.07 214.97 59.24 214.97 42.41",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 49.39 216.31 51.22 216.31 58.47 219.48 56.64 219.48 49.39",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 49.39 216.31 51.22 216.31 58.47 219.48 56.64 219.48 49.39",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--puzzle-pieces--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Piece--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.58,425.37v-3.58l1.48-.89c5-3,9.38-5.55,11.6-5.61a1.93,1.93,0,0,1,2.22,1.62,1.94,1.94,0,0,0,1,1.47c1.46.84,4.4.51,6.55-.74a6.53,6.53,0,0,0,.7-.46,6.86,6.86,0,0,0-1.95-.32c-1.31-.05-2.81-.4-2.82-1.22a.13.13,0,0,1,0-.06c.05-.63,0-2.84,0-3.53a.13.13,0,0,1,0-.06c.12-1.51,4.77-4.13,9.89-6.76l1.1.63c4.63,2.68,7.43,4.3,9.94,4.17a3.44,3.44,0,0,0,3.17-2.1,2.78,2.78,0,0,1,1.22-1.4,6.36,6.36,0,0,1,5.73.24,2.37,2.37,0,0,1,1.4,1.86c0,.54,0,2.93,0,3.58a1.71,1.71,0,0,1-1,1.45,6.22,6.22,0,0,1-2.42.71,8.79,8.79,0,0,0-2,.48,52.77,52.77,0,0,0,5.42,3.41l.84.49,1,.56v3.58s-9,5.79-11.42,5.86a1.94,1.94,0,0,1-2.22-1.63,1.93,1.93,0,0,0-1-1.47c-1.45-.83-4.39-.5-6.55.74-.26.15-.49.31-.7.46a6.52,6.52,0,0,0,2,.32c1.32.06,2.82.41,2.83,1.23v.06c0,.56,0,2.79,0,3.52v.07c-.13,1.43-5.89,4.53-11.52,7.43l-3-1.79c-3.33-2-5.52-3.34-7.64-3.22a3.44,3.44,0,0,0-3.17,2.1,2.71,2.71,0,0,1-1.22,1.39,6.36,6.36,0,0,1-5.73-.23,2.33,2.33,0,0,1-1.39-1.85c0-.55,0-2.94,0-3.59a1.68,1.68,0,0,1,1-1.45,6.22,6.22,0,0,1,2.42-.71,9.18,9.18,0,0,0,1.87-.41c-1.13-.79-2.73-1.68-4.59-2.72Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,425.37v-3.58l1.48-.89c5-3,9.38-5.55,11.6-5.61a1.93,1.93,0,0,1,2.22,1.62,1.94,1.94,0,0,0,1,1.47c1.46.84,4.4.51,6.55-.74a6.53,6.53,0,0,0,.7-.46,6.86,6.86,0,0,0-1.95-.32c-1.31-.05-2.81-.4-2.82-1.22a.13.13,0,0,1,0-.06c.05-.63,0-2.84,0-3.53a.13.13,0,0,1,0-.06c.12-1.51,4.77-4.13,9.89-6.76l1.1.63c4.63,2.68,7.43,4.3,9.94,4.17a3.44,3.44,0,0,0,3.17-2.1,2.78,2.78,0,0,1,1.22-1.4,6.36,6.36,0,0,1,5.73.24,2.37,2.37,0,0,1,1.4,1.86c0,.54,0,2.93,0,3.58a1.71,1.71,0,0,1-1,1.45,6.22,6.22,0,0,1-2.42.71,8.79,8.79,0,0,0-2,.48,52.77,52.77,0,0,0,5.42,3.41l.84.49,1,.56v3.58s-9,5.79-11.42,5.86a1.94,1.94,0,0,1-2.22-1.63,1.93,1.93,0,0,0-1-1.47c-1.45-.83-4.39-.5-6.55.74-.26.15-.49.31-.7.46a6.52,6.52,0,0,0,2,.32c1.32.06,2.82.41,2.83,1.23v.06c0,.56,0,2.79,0,3.52v.07c-.13,1.43-5.89,4.53-11.52,7.43l-3-1.79c-3.33-2-5.52-3.34-7.64-3.22a3.44,3.44,0,0,0-3.17,2.1,2.71,2.71,0,0,1-1.22,1.39,6.36,6.36,0,0,1-5.73-.23,2.33,2.33,0,0,1-1.39-1.85c0-.55,0-2.94,0-3.59a1.68,1.68,0,0,1,1-1.45,6.22,6.22,0,0,1,2.42-.71,9.18,9.18,0,0,0,1.87-.41c-1.13-.79-2.73-1.68-4.59-2.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,434.15a6.42,6.42,0,0,0,5.73.23,2.69,2.69,0,0,0,1.22-1.4,3.46,3.46,0,0,1,3.17-2.1c2.12-.11,4.31,1.21,7.64,3.22.88.54,1.9,1.15,3,1.79,5.63-2.89,11.39-6,11.52-7.43v-.06c0-.82-1.51-1.17-2.83-1.23a5.33,5.33,0,0,1-2.53-.58c-1.46-.83-.88-2.53,1.28-3.78s5.1-1.58,6.55-.74a1.93,1.93,0,0,1,1,1.47,2,2,0,0,0,2.22,1.63c2.43-.08,6.4-2.61,11.42-5.86l-.08-.05-.89-.51-.84-.49c-4.26-2.46-7.24-4.27-7-5.65.17-1.05,2.06-1.64,3.63-1.83a6,6,0,0,0,2.42-.71,1.7,1.7,0,0,0,1-1.44,2.37,2.37,0,0,0-1.4-1.86,6.36,6.36,0,0,0-5.73-.24,2.78,2.78,0,0,0-1.22,1.4,3.44,3.44,0,0,1-3.17,2.1c-2.51.13-5.31-1.49-9.94-4.17l-1.1-.63c-5.12,2.63-9.77,5.25-9.89,6.76a.13.13,0,0,0,0,.06c0,.82,1.51,1.17,2.82,1.22a5.61,5.61,0,0,1,2.55.59c1.45.84.86,2.53-1.3,3.78s-5.09,1.58-6.55.74a1.94,1.94,0,0,1-1-1.47,1.93,1.93,0,0,0-2.22-1.62c-2.22.06-6.57,2.64-11.6,5.61l-1.48.89,2.93,1.63c3.8,2.11,6.56,3.64,6.35,4.88-.17,1.05-2.06,1.64-3.63,1.83a6.22,6.22,0,0,0-2.42.71,1.68,1.68,0,0,0-1,1.45A2.33,2.33,0,0,0,173.21,434.15Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,434.15a6.42,6.42,0,0,0,5.73.23,2.69,2.69,0,0,0,1.22-1.4,3.46,3.46,0,0,1,3.17-2.1c2.12-.11,4.31,1.21,7.64,3.22.88.54,1.9,1.15,3,1.79,5.63-2.89,11.39-6,11.52-7.43v-.06c0-.82-1.51-1.17-2.83-1.23a5.33,5.33,0,0,1-2.53-.58c-1.46-.83-.88-2.53,1.28-3.78s5.1-1.58,6.55-.74a1.93,1.93,0,0,1,1,1.47,2,2,0,0,0,2.22,1.63c2.43-.08,6.4-2.61,11.42-5.86l-.08-.05-.89-.51-.84-.49c-4.26-2.46-7.24-4.27-7-5.65.17-1.05,2.06-1.64,3.63-1.83a6,6,0,0,0,2.42-.71,1.7,1.7,0,0,0,1-1.44,2.37,2.37,0,0,0-1.4-1.86,6.36,6.36,0,0,0-5.73-.24,2.78,2.78,0,0,0-1.22,1.4,3.44,3.44,0,0,1-3.17,2.1c-2.51.13-5.31-1.49-9.94-4.17l-1.1-.63c-5.12,2.63-9.77,5.25-9.89,6.76a.13.13,0,0,0,0,.06c0,.82,1.51,1.17,2.82,1.22a5.61,5.61,0,0,1,2.55.59c1.45.84.86,2.53-1.3,3.78s-5.09,1.58-6.55.74a1.94,1.94,0,0,1-1-1.47,1.93,1.93,0,0,0-2.22-1.62c-2.22.06-6.57,2.64-11.6,5.61l-1.48.89,2.93,1.63c3.8,2.11,6.56,3.64,6.35,4.88-.17,1.05-2.06,1.64-3.63,1.83a6.22,6.22,0,0,0-2.42.71,1.68,1.68,0,0,0-1,1.45A2.33,2.33,0,0,0,173.21,434.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--piece--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.57,436.23s-7.27-3.85-9.15-5.21a8.83,8.83,0,0,1,1.26-.14,5,5,0,0,0,2.26-.51,1.19,1.19,0,0,0,.69-1.05v-3.58c0-.73-.68-1.61-1.91-2.33-2-1.13-4.58-1.45-5.86-.71A1.69,1.69,0,0,0,270,424c-.11.89-.87,1.91-2.69,1.87-2.68-.08-6.63-2.62-12.05-6.13l-.1.06c-1,.58-1.93,1.13-2.77,1.63s-1.41.85-2,1.21c-2.35,1.36-4,2.13-5.73,2a3.48,3.48,0,0,1-3.19-2.11,2.66,2.66,0,0,0-1.21-1.39,6.39,6.39,0,0,0-5.73.23,2.4,2.4,0,0,0-1.4,1.84c0,.55,0,2.94,0,3.58a1.73,1.73,0,0,0,1,1.48,6.45,6.45,0,0,0,2.42.7,9.33,9.33,0,0,1,1.87.41c-1.14.79-2.74,1.68-4.6,2.71l-2.9,1.63v3.59s10,6.33,12.52,6.41a1.94,1.94,0,0,0,2.22-1.63,2,2,0,0,1,1-1.47c1.45-.83,4.39-.5,6.55.75a6.53,6.53,0,0,1,.7.46,7.24,7.24,0,0,1-2,.32c-1.32.05-2.83.4-2.83,1.23a.13.13,0,0,0,0,.06c.05.62,0,3.56,0,3.58.12,1.44,4.47,3.79,10.17,6.72,1-.58,2-1.12,3-1.64,3.47-1.93,6.24-3.46,6.23-4.57V444a.41.41,0,0,0,0-.11c-.14-.87-1.79-1.37-3.16-1.53a7.11,7.11,0,0,1-2.62-.76c.09-.06.16-.12.25-.17a7.14,7.14,0,0,1,6.45-.21,3.07,3.07,0,0,1,1.38,1.57,2.92,2.92,0,0,0,2.66,1.83c1.94.11,4-1.12,7.41-3.17l2.76-1.63Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,436.23s-7.27-3.85-9.15-5.21a8.83,8.83,0,0,1,1.26-.14,5,5,0,0,0,2.26-.51,1.19,1.19,0,0,0,.69-1.05v-3.58c0-.73-.68-1.61-1.91-2.33-2-1.13-4.58-1.45-5.86-.71A1.69,1.69,0,0,0,270,424c-.11.89-.87,1.91-2.69,1.87-2.68-.08-6.63-2.62-12.05-6.13l-.1.06c-1,.58-1.93,1.13-2.77,1.63s-1.41.85-2,1.21c-2.35,1.36-4,2.13-5.73,2a3.48,3.48,0,0,1-3.19-2.11,2.66,2.66,0,0,0-1.21-1.39,6.39,6.39,0,0,0-5.73.23,2.4,2.4,0,0,0-1.4,1.84c0,.55,0,2.94,0,3.58a1.73,1.73,0,0,0,1,1.48,6.45,6.45,0,0,0,2.42.7,9.33,9.33,0,0,1,1.87.41c-1.14.79-2.74,1.68-4.6,2.71l-2.9,1.63v3.59s10,6.33,12.52,6.41a1.94,1.94,0,0,0,2.22-1.63,2,2,0,0,1,1-1.47c1.45-.83,4.39-.5,6.55.75a6.53,6.53,0,0,1,.7.46,7.24,7.24,0,0,1-2,.32c-1.32.05-2.83.4-2.83,1.23a.13.13,0,0,0,0,.06c.05.62,0,3.56,0,3.58.12,1.44,4.47,3.79,10.17,6.72,1-.58,2-1.12,3-1.64,3.47-1.93,6.24-3.46,6.23-4.57V444a.41.41,0,0,0,0-.11c-.14-.87-1.79-1.37-3.16-1.53a7.11,7.11,0,0,1-2.62-.76c.09-.06.16-.12.25-.17a7.14,7.14,0,0,1,6.45-.21,3.07,3.07,0,0,1,1.38,1.57,2.92,2.92,0,0,0,2.66,1.83c1.94.11,4-1.12,7.41-3.17l2.76-1.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,436.23c-1,.58-1.92,1.13-2.76,1.63-3.4,2-5.47,3.27-7.41,3.16a2.92,2.92,0,0,1-2.66-1.83,3.08,3.08,0,0,0-1.38-1.56,7.17,7.17,0,0,0-6.45.2c-1.87,1.08-2,2.74-.34,3.71a6.88,6.88,0,0,0,2.71.81c1.37.16,3,.66,3.16,1.53a.41.41,0,0,1,0,.11c0,1.1-2.76,2.63-6.23,4.56-1,.52-1.94,1.07-3,1.65-5.7-2.93-10-5.29-10.17-6.72a.13.13,0,0,1,0-.06c0-.83,1.51-1.18,2.83-1.23a5.55,5.55,0,0,0,2.54-.58c1.46-.84.87-2.54-1.29-3.79s-5.1-1.57-6.55-.74a1.91,1.91,0,0,0-1,1.47,1.93,1.93,0,0,1-2.22,1.62c-2.56-.07-7.66-3.26-12.52-6.41,1-.57,2-1.11,2.9-1.63,3.81-2.11,6.56-3.64,6.36-4.87-.18-1.05-2.07-1.65-3.63-1.84a6.26,6.26,0,0,1-2.42-.7,1.7,1.7,0,0,1-1-1.47,2.4,2.4,0,0,1,1.4-1.84,6.39,6.39,0,0,1,5.73-.23,2.66,2.66,0,0,1,1.21,1.39,3.48,3.48,0,0,0,3.19,2.11c1.71.09,3.38-.68,5.73-2,.63-.36,1.3-.76,2-1.21s1.76-1.05,2.77-1.63l.1-.06c5.42,3.51,9.37,6.05,12.05,6.13,1.82,0,2.58-1,2.69-1.87a1.69,1.69,0,0,1,.87-1.3c1.28-.74,3.9-.42,5.86.71,1.23.72,1.91,1.6,1.91,2.33a1.18,1.18,0,0,1-.69,1,4.74,4.74,0,0,1-2.26.51c-1.54.07-3.3.51-3.21,1.55C272.58,430.29,276.8,432.74,283.57,436.23Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,436.23c-1,.58-1.92,1.13-2.76,1.63-3.4,2-5.47,3.27-7.41,3.16a2.92,2.92,0,0,1-2.66-1.83,3.08,3.08,0,0,0-1.38-1.56,7.17,7.17,0,0,0-6.45.2c-1.87,1.08-2,2.74-.34,3.71a6.88,6.88,0,0,0,2.71.81c1.37.16,3,.66,3.16,1.53a.41.41,0,0,1,0,.11c0,1.1-2.76,2.63-6.23,4.56-1,.52-1.94,1.07-3,1.65-5.7-2.93-10-5.29-10.17-6.72a.13.13,0,0,1,0-.06c0-.83,1.51-1.18,2.83-1.23a5.55,5.55,0,0,0,2.54-.58c1.46-.84.87-2.54-1.29-3.79s-5.1-1.57-6.55-.74a1.91,1.91,0,0,0-1,1.47,1.93,1.93,0,0,1-2.22,1.62c-2.56-.07-7.66-3.26-12.52-6.41,1-.57,2-1.11,2.9-1.63,3.81-2.11,6.56-3.64,6.36-4.87-.18-1.05-2.07-1.65-3.63-1.84a6.26,6.26,0,0,1-2.42-.7,1.7,1.7,0,0,1-1-1.47,2.4,2.4,0,0,1,1.4-1.84,6.39,6.39,0,0,1,5.73-.23,2.66,2.66,0,0,1,1.21,1.39,3.48,3.48,0,0,0,3.19,2.11c1.71.09,3.38-.68,5.73-2,.63-.36,1.3-.76,2-1.21s1.76-1.05,2.77-1.63l.1-.06c5.42,3.51,9.37,6.05,12.05,6.13,1.82,0,2.58-1,2.69-1.87a1.69,1.69,0,0,1,.87-1.3c1.28-.74,3.9-.42,5.86.71,1.23.72,1.91,1.6,1.91,2.33a1.18,1.18,0,0,1-.69,1,4.74,4.74,0,0,1-2.26.51c-1.54.07-3.3.51-3.21,1.55C272.58,430.29,276.8,432.74,283.57,436.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.35,51.85A21.23,21.23,0,1,0,416.56,30.6,21.25,21.25,0,0,0,395.35,51.85Zm1.91,0a19.32,19.32,0,1,1,19.34,19.3A19.34,19.34,0,0,1,397.26,51.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,51.85a19.32,19.32,0,1,0,19.3-19.34A19.34,19.34,0,0,0,397.26,51.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.75,78.91l2.72-7h-7.74l2.72,7A1.23,1.23,0,0,0,417.75,78.91Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.34,61.51h6.49a.49.49,0,0,0,0-1h-6.49a.49.49,0,0,0,0,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.85,62.84a.49.49,0,0,1,.49-.49h6.49a.49.49,0,0,1,.49.49,3.74,3.74,0,0,1-7.47,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,48.2a10.09,10.09,0,0,0,5,8.65,2.7,2.7,0,0,1,1.33,2.29.44.44,0,0,0,.44.44h6.67a.48.48,0,0,0,.31-.12.48.48,0,0,0,.13-.32,2.67,2.67,0,0,1,1.33-2.29A10.06,10.06,0,0,0,426.63,48a10.18,10.18,0,0,0-9.56-9.88,10.07,10.07,0,0,0-10.54,10Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.53,48.2a10.09,10.09,0,0,0,5,8.65,2.7,2.7,0,0,1,1.33,2.29.44.44,0,0,0,.44.44h6.67a.48.48,0,0,0,.31-.12.48.48,0,0,0,.13-.32,2.67,2.67,0,0,1,1.33-2.29A10.06,10.06,0,0,0,426.63,48a10.18,10.18,0,0,0-9.56-9.88,10.07,10.07,0,0,0-10.54,10Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M420,52.89a4.21,4.21,0,0,1-2.45,1.1v5.59h-1.7V54.05a9.37,9.37,0,0,1-2-.36,6,6,0,0,1-1.57-.72l.92-2.07a6,6,0,0,0,1.55.71,5.83,5.83,0,0,0,1.73.27q1.62,0,1.62-.81a.66.66,0,0,0-.46-.63,8.22,8.22,0,0,0-1.49-.44,13.39,13.39,0,0,1-1.87-.52A3.17,3.17,0,0,1,413,48.6a2.41,2.41,0,0,1-.54-1.65,2.86,2.86,0,0,1,.88-2.1,4.23,4.23,0,0,1,2.54-1.07V42.22h1.7v1.53a8.78,8.78,0,0,1,1.56.29,5.71,5.71,0,0,1,1.33.55l-.87,2.09a5.83,5.83,0,0,0-2.76-.77,2.39,2.39,0,0,0-1.22.25.76.76,0,0,0-.38.65.63.63,0,0,0,.45.59,8.22,8.22,0,0,0,1.47.42,14.82,14.82,0,0,1,1.88.51,3.27,3.27,0,0,1,1.29.88,2.39,2.39,0,0,1,.55,1.64A2.78,2.78,0,0,1,420,52.89Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.83,307.25l1.57-13.93-15.86-1.43s.67,10.74.57,15.66c0,2.32-1.68,6.69-1.68,6.69s6.63,3.44,10.08,2,5.72-6.84,5.64-7.83S409.83,307.25,409.83,307.25Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,329.16c-.22,0-.38,2,.83,3A15.59,15.59,0,0,0,388,334.73c5.31-.77,8.16-2.44,10.26-4.23s5-4.32,7.44-4.89a17.25,17.25,0,0,0,5.92-3.05c.71-.7.55-3.72.55-3.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.83,307.22a.86.86,0,0,1,.82.7c.18.83.4,3.25.78,4.62a23.73,23.73,0,0,1,.66,7.34c-.26,1.56-4.48,3.49-6.79,4.41a29.71,29.71,0,0,0-7.46,4.82c-2.47,2.08-7.69,4.28-11.16,4.32-4.11,0-8.75-1.19-9.85-3.05-1.35-2.29-2.35-5,3.68-7.85,1.14-.55,5.15-3,6.51-3.86,3.69-2.37,6.27-4.54,7.92-8.67a2.25,2.25,0,0,1,.85-1.26,1.9,1.9,0,0,1,1.18-.13,39.78,39.78,0,0,1,6,1c.83.37,2,.8,2,1.83a3.44,3.44,0,0,1-.21,1.05c-.07.21-.13.49.06.61s.41,0,.57-.16a16.87,16.87,0,0,0,1.61-2,16.3,16.3,0,0,1,1.53-1.78,12.22,12.22,0,0,0,1-.68C409.92,308.16,409.82,307.71,409.83,307.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.84,329.11a39.15,39.15,0,0,1,3.27-2.49h0s-7.08,4.41-10,2.52c-1.88-1.23-1-2.76-1-3.25s-6.61-3.81-8.42-4h0c-.5.28-.91.53-1.18.64-4.72,2-5.31,4.37-4.46,7.39,1.1,1.86,5.25,3.72,10.56,3.63C390.08,333.49,395.37,331.19,397.84,329.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59,324.45c-3.76,1.56-2.13,2.23-1.07,2.36s7.36-3.65,11.19-6.74c4-3.23,7.08-7.52,8.56-8.71.55-.44,1.15-1,1.68-1.49-.12-.81-.21-1.56-.3-1.95a.86.86,0,0,0-.82-.7c0,.49.09.94-.27,1.31a12.22,12.22,0,0,1-1,.68A16.3,16.3,0,0,0,407,311a16.87,16.87,0,0,1-1.61,2C402.16,317.14,394.34,322.9,390.59,324.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.78,326.25a.4.4,0,0,0,.23-.08.37.37,0,0,0,.05-.52c-1.1-1.27-6.22-4.24-9-3.89a.36.36,0,0,0-.32.41.37.37,0,0,0,.42.32c2.59-.32,7.46,2.63,8.32,3.63A.36.36,0,0,0,389.78,326.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,324.2a.44.44,0,0,0,.24-.09.38.38,0,0,0,0-.52c-1.09-1.27-6.21-4.24-9-3.89a.37.37,0,1,0,.09.73c2.6-.32,7.46,2.63,8.33,3.64A.39.39,0,0,0,393,324.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.31,322.24a.38.38,0,0,0,.23-.08.37.37,0,0,0,0-.52c-1.1-1.27-6.21-4.24-9-3.89a.36.36,0,0,0-.33.41.38.38,0,0,0,.42.32c2.6-.32,7.46,2.63,8.33,3.63A.33.33,0,0,0,396.31,322.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,320a.33.33,0,0,0,.23-.09.37.37,0,0,0,.05-.52c-1.09-1.27-6.23-4.24-9-3.89a.37.37,0,1,0,.09.73c2.59-.32,7.46,2.63,8.33,3.64A.39.39,0,0,0,399.33,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.29,317.81a.4.4,0,0,0,.23-.08.37.37,0,0,0,.05-.52c-1.5-1.8-6.85-4.27-9.63-3.92a.37.37,0,1,0,.09.73c2.5-.31,7.63,2.06,9,3.66A.39.39,0,0,0,402.29,317.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,313.79l-3.78-16.73,16.5-2.57L449.1,311s1.26,4.44.34,6-10.85,3.14-11.75,2.12S436.12,313.79,436.12,313.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.76,340.14c.44,3.75,1.22,6.18,2.85,8.21s4.51,2.38,7.37,1.37,6.49-3.19,7.16-6.55a18.54,18.54,0,0,0-.44-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,311c1.2-.06.88,2.89,1.44,7.95.61,5.47,3.08,9.76,4,14.14,1,5,.81,7.33-1.06,10.67S444.57,351,440.83,347c-3-3.25-3.36-7.23-3.35-12.36a112.66,112.66,0,0,0-.37-13c-.42-3.8-2-7.3-1-7.85.1.55,1.12,4.39,1.79,4.33a6.92,6.92,0,0,0-.06-1.44,1.67,1.67,0,0,1,.27-1.28,5.44,5.44,0,0,1,1.92-1c1.16-.35,3.24-.79,4.43-1,.59-.12,1.19-.22,1.78-.29a5.52,5.52,0,0,1,1.52,0,.9.9,0,0,1,.67.44,1.39,1.39,0,0,1,.09.58,3.5,3.5,0,0,0,.21,1c.05.15.17.32.34.26a.3.3,0,0,0,.18-.33C449.24,314.47,449.15,311.32,449.1,311Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.15,331.67c.16.73,1.1,5.52-.36,6.58s-2.65-2.58-2.65-2.58-3.86-.56-9.29,2.26c.32.76-.4,3.47-2,3.11s-2.4-5.88-2.42-6c0,4.92.4,8.77,3.35,11.92,3.74,4,10.74.09,12.61-3.24s2.06-5.65,1.06-10.67C454.4,332.59,454.28,332.12,454.15,331.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.72,336.05c.12,1.85,2.14,1,2.1-1.65s-1.41-9-1.93-13.24c-.34-6.16-.59-10.22-1.79-10.16,0,.06,0,.12,0,.19s.12,3.5.14,3.9c.22,3.76.26,11.07.8,14.46A52.89,52.89,0,0,1,450.72,336.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.49,337.8a51.43,51.43,0,0,1-1.45-6.33c-.58-3.36-2.59-10.09-3.59-13.71-.32-.59-1.33-4-1.33-4-.83.23,0,3.45.38,5s.86,3.13,1.35,5.29c1.24,4.27,1.35,10.67,2.15,13.13S443,339.57,442.49,337.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.74,338.1l.16-.07a16.41,16.41,0,0,1,9.14-2,.5.5,0,0,0,.53-.35.37.37,0,0,0-.34-.44,17.14,17.14,0,0,0-9.77,2.11.38.38,0,0,0-.16.55A.43.43,0,0,0,441.74,338.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.55,334.21l.14,0a20.29,20.29,0,0,1,10.24-2.2.49.49,0,0,0,.52-.36.37.37,0,0,0-.36-.43,21,21,0,0,0-10.81,2.33.39.39,0,0,0-.18.55A.42.42,0,0,0,440.55,334.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46,328.19a.47.47,0,0,0,.36-.31.36.36,0,0,0-.3-.46c-5.43-.95-10.59,2.1-10.81,2.23a.39.39,0,0,0-.16.55.47.47,0,0,0,.61.1s5.06-3,10.11-2.1A.61.61,0,0,0,450.46,328.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,324.64a.46.46,0,0,0,.36-.3.35.35,0,0,0-.29-.47,15.81,15.81,0,0,0-11,2.23.38.38,0,0,0-.12.56.47.47,0,0,0,.61.06,15,15,0,0,1,10.27-2.08A.41.41,0,0,0,450,324.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,320.66a.48.48,0,0,0,.36-.3.35.35,0,0,0-.28-.47c-5.6-1.16-10.88,2.2-11.1,2.35a.38.38,0,0,0-.14.55.46.46,0,0,0,.61.07c.06,0,5.15-3.27,10.35-2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.55,184.83c3.65,19.95,2.49,73.95,2.49,73.95.2,2.25,1.49,5.41,2.53,16.52,1.1,11.73,1.06,28.47,1.06,28.47s-9.91,4.24-16.07,2.05c0,0-6.62-25.12-9.83-38.93-3-13.07-5.26-33.51-5.26-33.51l-3.6,19.69s.45,8.46.24,14.38c-.25,6.89-4,33.26-4,33.26s-9.21,5.51-15.62.25c0,0-4.32-38.77-4.53-47-.41-16.25.33-48.13,2.25-69.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.47,233.38l-3.24-21.11s-7.46-1.13-11.3-4.83c0,0,2.49,4.9,9.53,6.78l3.21,19.22-1.8,19.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354,149c1.67,1.73,3.3,4.3,6.13,7.36s7,8.32,11.31,11.72,6.4,4.82,13-.37a161.39,161.39,0,0,0,17.08-16.26l6.23-21.17c-6.25.12-9.14,2-13.85,6.74l-16.79,17s-12.55-9.93-14.15-11.45a7.32,7.32,0,0,1-2.24-4.29,34.82,34.82,0,0,0-.85-4.07c-.36-1.42-.5-2-.9-3.74s-.49-4.68-.6-5.34c-.29-.76-1.36-.85-2.5.75a6.91,6.91,0,0,0-.89,3.36c-.1,1,0,2.35-.3,2.47s-1.7-.84-3.13-1.41-2.64-1.38-4.35-1.13a2,2,0,0,0-1.71,2.37,2.51,2.51,0,0,0,.73,1.12,2.1,2.1,0,0,0-1.64.26,2.28,2.28,0,0,0-.45,2.86,1.29,1.29,0,0,0-1.42,1c-.32.94-.35,1.92.56,2.44,0,0-.82.07-.94.53a2.31,2.31,0,0,0,.44,2.24,7.63,7.63,0,0,0,2.68,1.06s.1.37.95,1a23.7,23.7,0,0,0,2.85,2.11C350.36,146.73,352.63,147.6,354,149Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,141.09a.87.87,0,0,1-.3.68,6.13,6.13,0,0,1-.8.59l-.41.26a2.07,2.07,0,0,1-.44.15l-1,.21a4.1,4.1,0,0,0,1.05.07,1.3,1.3,0,0,0,.54-.13,4.45,4.45,0,0,0,.48-.26,5.21,5.21,0,0,0,.8-.7,1.14,1.14,0,0,0,.22-.52.78.78,0,0,0-.06-.35,5.43,5.43,0,0,0,.82-.18,2.59,2.59,0,0,0,1.19-.6,1.81,1.81,0,0,0,.31-.6.78.78,0,0,0,0-.22l.37-.39a5.74,5.74,0,0,0,1,2.52,6.76,6.76,0,0,0,2.5,2.21,5.95,5.95,0,0,1-1.75-7.71H353a1,1,0,0,0,.37-.34,1.26,1.26,0,0,0,.16-.9,2.75,2.75,0,0,0-.29-.82,4.9,4.9,0,0,0-2.55-2,2.46,2.46,0,0,0-.32-.65,3.35,3.35,0,0,0-.49-.57,3.75,3.75,0,0,1,.42.62,2,2,0,0,1,.25.67v0l0,0a4.93,4.93,0,0,1,2.35,2,1.38,1.38,0,0,1,.13,1.36c-.16.22-.26.27-.51.2s-.5-.17-.76-.24c-.54-.16-1.07-.25-1.58-.39a6.64,6.64,0,0,1-1.46-.61c-.46-.27-.9-.59-1.34-.9a11.2,11.2,0,0,1-1.28-1,13.19,13.19,0,0,0,2.48,2.11,5.47,5.47,0,0,0,1.51.7c.53.16,1.06.25,1.57.41l.3.11a1,1,0,0,1,.26.67,1.11,1.11,0,0,1-.71,1,7,7,0,0,1-1.26.5,4,4,0,0,1-1.32.11,9.62,9.62,0,0,1-2.45-1.17c-.82-.45-1.63-.89-2.48-1.3.77.54,1.55,1.05,2.33,1.55.39.25.79.49,1.2.73a4,4,0,0,0,1.35.55,3.89,3.89,0,0,0,.9-.05,1.35,1.35,0,0,1,.65.57.64.64,0,0,1,0,.52,1.86,1.86,0,0,1-.31.49,2.76,2.76,0,0,1-1.07.47,2.68,2.68,0,0,1-1.17.13,5.06,5.06,0,0,1-1.1-.51,7.94,7.94,0,0,0-1.2-.45c-.82-.24-1.64-.45-2.47-.61.79.31,1.59.59,2.38.88.39.15.78.29,1.15.47a4.41,4.41,0,0,0,1.17.58A2.17,2.17,0,0,0,348.38,141.09Zm3.85-5.05,0,0h0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.13,129.93c-5.43.26-7.6,1.43-13,6.27s-17,17.42-17,17.42l-11.25-8.54s.79,1.75-1.9,5.49a7.64,7.64,0,0,1-6.42,3.42s7,8.12,10.2,11.22,7,6.17,9,6.36,3.58-.45,8-3.66,22.35-19.44,22.35-19.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.89,148.86c3.14-1.55,6.1-1.41,7.11-5.36.79-3.07-1.07-6.27-1.38-9.17-.34-3.25,1.4-7-.6-9.56-1.35-1.76-3.94-2.17-5.36-3.88-1.94-2.34-.9-6-2.22-8.74a5.6,5.6,0,0,0-6.13-2.9c-2.76.66-5.2.53-7.79,1.7s-4.86,3.46-5.21,6.27c-.39,3.13,1.59,6.2,1.18,9.33-.24,1.9-1.34,3.57-2.12,5.32s-1.2,3.91-.15,5.52,3.17,2.1,4.58,3.4c2.26,2.11,2.16,5.72,3.71,8.39a7.7,7.7,0,0,0,10,2.73C439.09,151.05,440.29,149.64,441.89,148.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.29,129.88l21.83.93,6.79,1.63c2,.89,4.68,6.19,3.79,18.45-.36,4.93-1.89,13.93-1.93,17.62,0,5.38,4.51,12.77,5,23.25-16.13,9.91-46.74,6.9-52.52,1.59.75-10.36,1.15-11.4,2.48-20.12a129.63,129.63,0,0,0,1.27-13.1s-3.09-5.2-2.84-8.7c.37-5.15,1.44-7,6.15-12.72,4.48-5.47,7.79-8.78,7.79-8.78Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,94.33c5.54.61,6.88,9.67,5.57,14.78-2.54,9.87-9.2,11-9.46,15.23l-10-5.85L408.72,114a27.32,27.32,0,0,1-4.74-3.37c-1.41-1.27-3.05-1.86-3.92-3.69a8.42,8.42,0,0,1-.42-5.45,2.76,2.76,0,0,1-2-1.63,4.64,4.64,0,0,1-.26-2.61c.44-2.7,2.4-4.91,4.55-6.58.31-.24.62-.48.94-.7a21.55,21.55,0,0,1,15.82-3.79C423.54,87,428.82,89.15,430.32,94.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.2,128.29l.55-9.15a4,4,0,0,0,4.91-1c2.73-2.83,3-5.92,1.51-7.9-1.64-2.19-5.29-1.36-6.86,1.31-2.38.57-3.34-2.83-1.54-6.31,0,0-11.51.78-16.85-8a2.89,2.89,0,0,0-4.65.72c-.57,1.3-1.31,3.47-.77,7.87.19,1.63-.59,3.58-.53,5.78.24,8.7,2.22,11.5,4.6,13a13.33,13.33,0,0,0,6.5,1.47l-.19,2.34h0c-.05,1.27-.35,1.31-1.45,1.37l-1.65.1,3.41,10.93c3.67-4.71,10.08-6,17.58-9.54l-1.83-.27C426.92,130.72,426.37,130,426.2,128.29Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72,116,411,117.5a2.44,2.44,0,0,0,3.08,1.69A2.6,2.6,0,0,0,415.72,116Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42,117.07a2.71,2.71,0,0,0-2.72,2.14,2.37,2.37,0,0,0,1.37,0,2.57,2.57,0,0,0,1.72-2.07A2.52,2.52,0,0,0,415.42,117.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.09,104.14l3.13-1.4a1.65,1.65,0,0,0-2.21-.91A1.81,1.81,0,0,0,404.09,104.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.54,106.79a1.46,1.46,0,0,1-1.31,1.56,1.38,1.38,0,0,1-1.54-1.25,1.49,1.49,0,0,1,1.31-1.57A1.38,1.38,0,0,1,407.54,106.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.06,105.4,416,103.74a1.68,1.68,0,0,1,2.31-.74A1.83,1.83,0,0,1,419.06,105.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.35,107.1a1.47,1.47,0,0,1-1.31,1.56,1.38,1.38,0,0,1-1.53-1.26,1.46,1.46,0,0,1,1.31-1.56A1.37,1.37,0,0,1,418.35,107.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.91 104.21 411.9 113.98 407.13 111.46 412.91 104.21",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.07,126.09c6.3.1,10.29-2.2,12-6a9.41,9.41,0,0,1-3.1,5.48c-2.87,2.16-9.06,2.24-9.06,2.24Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.12,130.81a17.18,17.18,0,0,1-2-1.21c-1.22-.83-1.59-1.79-2.89-1.79-.74,3.41-5,6.72-8.31,8.07s-4.73,5-4.73,5,3.83-3.55,6.36-2.47,7.38,3.91,7.38,3.91a32.09,32.09,0,0,0,3.42-6.65A13.76,13.76,0,0,0,431.12,130.81Zm-19.48,3.88c-.3-1.07.66-5,.66-5s.53,0,.58-1.06c0-.07,0-.55,0-.63a4.54,4.54,0,0,0-.92.59,14.32,14.32,0,0,1-2.69,1.28s-4.31,4.19-5.58,8.48c2.38-1.72,4.66-2.06,6.57-.87a6.34,6.34,0,0,1,2.91,3.34C413.36,138.79,411.94,135.76,411.64,134.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.31 159.74 406.63 164.86 422.77 208.44 387.17 202.64 369.31 159.74",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.39,191.16a8.66,8.66,0,0,0,6.32,6,34.52,34.52,0,0,0,10.36.21l-1.85-5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.08,165l-.47-1.34c-.26-.75,1.86-1,4.73-.65l5.5.73c2.87.38,5.41,1.29,5.66,2l.47,1.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,160.05c-.16-.46.68-.69,1.89-.51l2.18.32s-1-2.9,3.81-2.43,6.25,3.74,6.25,3.74l2.33.36c1.29.2,2.49.74,2.7,1.19l.37.83-19.23-2.64Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,160.05c-.16-.46.68-.69,1.89-.51l2.18.32s-1-2.9,3.81-2.43,6.25,3.74,6.25,3.74l2.33.36c1.29.2,2.49.74,2.7,1.19l.37.83-19.23-2.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,165.88c-.22-.61-2-1.34-4.26-1.79,0-.08-.05-.16-.07-.22-.21-.65,0-1.08,1.38-.89l0-.54-13.32-1.72.62.51c1.75.2,2.49.34,2.89,1.49l.08.26c-2.08-.12-3.47.18-3.26.78l.47,1.35,15.89,2.12Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,165.88c-.22-.61-2-1.34-4.26-1.79,0-.08-.05-.16-.07-.22-.21-.65,0-1.08,1.38-.89l0-.54-13.32-1.72.62.51c1.75.2,2.49.34,2.89,1.49l.08.26c-2.08-.12-3.47.18-3.26.78l.47,1.35,15.89,2.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.7,175.88a52.67,52.67,0,0,0-2.5-10.13l-15.1,6.65s-3.21,1.68-10.56,5.19c-4,1.91-7.56,3.33-11,2.62-1-.21-4.54-.7-5.59-.79s-2.28,0-3.42,0c-.72,0-2.53-.15-2.53-.15l1.42,3.83a5.28,5.28,0,0,1,.6.39c.45.29.42.82-.24,1.09a15.1,15.1,0,0,1-6,1,34.05,34.05,0,0,1-6-.75,4.16,4.16,0,0,0-1.05-.1,1.2,1.2,0,0,0-.91.48,1.26,1.26,0,0,0,.06,1.32,4.18,4.18,0,0,0,1,1,2.85,2.85,0,0,1,.85,1.1c.22.64,0,1.4.3,2s1.28.9,1.9,1.39a9,9,0,0,1,1.28,1.65,5.94,5.94,0,0,0,2.66,1.82c2.89,1.07,5.8.77,8.79.38,6.24-.81,10.95-3.21,13.94-4.13s6.8-1.6,15.74-4.07a98.21,98.21,0,0,0,11.93-3.79C461.4,182.66,463.33,180.91,462.7,175.88Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,170.75c-1.77-5.74-4.18-13.07-6.87-20.2A91.65,91.65,0,0,0,450.89,140c-2.32-4.81-7.49-5.94-13-7.59a26.13,26.13,0,0,0-1.62,20c1.91,6.05,8.32,19.65,8.32,19.65l-12.07,6.25a15.61,15.61,0,0,1,3.89,5.1c1.65,3.36-.39,7.39-.39,7.39s12.15-3.41,16.75-4.5,8.83-3.58,10-5.42S463.86,176.49,462.08,170.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.81,382.61,319,370.47l12.41,7.26-15.3,18.06s-7.58-.7-8.8-4.66S310.72,383.93,312.81,382.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.07,387.38a6.56,6.56,0,0,0-1.72,1.88c-.5.74-.34,4.34-.82,6s-.85,2.11-1.64,4.2c-.89,2.32-2.52,4.44-.68,10.39s4.81,8.8,7.31,10.25a6.48,6.48,0,0,0,3,.73s3.27-1.23,2.76-3.17S304.07,387.38,304.07,387.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.42,393.92a7.2,7.2,0,0,1-1.29,2.06,16.06,16.06,0,0,0-2.12,6c-1.93,9.42,1.82,14.21-3.26,17.75-1.47.92-4.52.67-9.15-5.27-2.37-3-3.72-9.28-2.8-12.1s2.19-4.67,2.79-6.84.28-6.23,1.48-8.1a9,9,0,0,1,2.94-2.53c.9-.54,2.87-1.26,3.79-1.79s1.42-1.11,2-.45l-1.06,1.31c-1.65,2.29-1.19,2.63-1.15,3.85a19.33,19.33,0,0,1-.61,3.88c1.17-1.48,1.65-2.78,2.94-2.55s1.44.16,3.28,1.89S318.5,393.38,318.42,393.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6,414.42c-2.37-3-3.72-9.28-2.8-12.1a27,27,0,0,1,1.09-2.74c0,.19-.1.38-.12.55-.06.36-.11.73-.14,1.1a8.43,8.43,0,0,0,.47,4.28c.53,1.17,1.76,4.12,3.35,4.18.9,0,1.65-.84,2-1.84.15-.43.39-1.57.39-1.57A13.84,13.84,0,0,1,311,408c2.3,1.53,2.22,1.86,2.22,1.86a6.12,6.12,0,0,0-.08,2,5,5,0,0,0,.86,2,3.15,3.15,0,0,0,.58.47,6.12,6.12,0,0,1-2.79,5.37C310.28,420.61,307.23,420.36,302.6,414.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,401.94a31.78,31.78,0,0,0-.59,7.53c-.87,2.41-1.63,2.34-1.73,1.09s1.56-6.44,2.8-10.73C315.3,400.54,315.15,401.26,315,401.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,386.82a5.27,5.27,0,0,1,.92-3.45c.23-.11.44-.21.61-.31,1-.56,1.42-1.11,2-.45l-1.06,1.31c-1.65,2.29-1.19,2.63-1.15,3.85a19.33,19.33,0,0,1-.61,3.88c-1,4.09-1.84,5.46-2.29,9.33s.32,6.46-.23,6.68-1.65-.22-1.85-3.32,1.17-8.31,2.13-10.77S309.47,388.47,309.27,386.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,406.55a.43.43,0,0,0,.2.11,9.26,9.26,0,0,1,6.18,3.62.39.39,0,0,0,.59-.5,10.05,10.05,0,0,0-6.62-3.88.38.38,0,0,0-.45.3A.4.4,0,0,0,306.56,406.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,403.33a.35.35,0,0,0,.19.1,10.34,10.34,0,0,1,6.51,4,.39.39,0,0,0,.56,0,.4.4,0,0,0,.05-.56,11.16,11.16,0,0,0-6.94-4.21.4.4,0,0,0-.47.3A.41.41,0,0,0,307.05,403.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,399.78a.52.52,0,0,0,.22.12,11.7,11.7,0,0,1,7.27,4.44.45.45,0,0,0,.62,0,.43.43,0,0,0,0-.61,12.63,12.63,0,0,0-7.74-4.73.44.44,0,0,0-.41.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5,396.74a.37.37,0,0,0,.21.12,11.42,11.42,0,0,1,7.11,4.34.43.43,0,0,0,.65-.56A12.29,12.29,0,0,0,307.9,396a.42.42,0,0,0-.51.32A.4.4,0,0,0,307.5,396.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,393.79a.4.4,0,0,0,.21.12,11.45,11.45,0,0,1,7.11,4.33.44.44,0,0,0,.61.05.42.42,0,0,0,0-.6,12.32,12.32,0,0,0-7.57-4.62.43.43,0,0,0-.51.32A.41.41,0,0,0,308.61,393.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.16 383.59 324.19 390.15 328.74 393.01 323.55 402.81 308.94 395.82 316.16 383.59",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,340.29S329,334.88,341.54,335c12.77.08,14,9.67,10.76,15.54-6.12,11.24-27.39,35.08-27.39,35.08s-7.14-3.27-9.34-9.45L320.43,365l-15.27,4.89-7.8-5.23-.63-4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,340.29S329,334.88,341.54,335c12.77.08,14,9.67,10.76,15.54-6.12,11.24-27.39,35.08-27.39,35.08s-7.14-3.27-9.34-9.45L320.43,365l-15.27,4.89-7.8-5.23-.63-4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,340.29l-47.79,7.86s-.5,12.12,4.27,23a24.74,24.74,0,0,0,18.94,14.46,142.24,142.24,0,0,0,15.31,1.25,38.31,38.31,0,0,0,8,4.7c4,1.61,21.66,9,21.66,9s4.95-4.19,4.46-12.93l-16.65-17.7c-3.77-4.59-5.09-6.08-7.18-7.11C299,348.19,298.05,346.45,297,340.29Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,340.29l-47.79,7.86s-.5,12.12,4.27,23a24.74,24.74,0,0,0,18.94,14.46,142.24,142.24,0,0,0,15.31,1.25,38.31,38.31,0,0,0,8,4.7c4,1.61,21.66,9,21.66,9s4.95-4.19,4.46-12.93l-16.65-17.7c-3.77-4.59-5.09-6.08-7.18-7.11C299,348.19,298.05,346.45,297,340.29Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323,355.53a106.7,106.7,0,0,0-6.44,10.72l3.9-1.25c4.39-10.47,5.29-13.52,12.32-18.43C332.75,346.57,327.71,348.47,323,355.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284,381s2.66,3.86,11.29,7.52c4.85,2,19.86,7.93,24.42,9a12,12,0,0,1-2.32,3s-17.63-7.38-21.66-9a25,25,0,0,1-2.57-1.2l-1.07-.6c-.9-.52-1.73-1.05-2.41-1.51s-1.22-.85-1.56-1.1l-.34-.26-.05,0C283.9,383.53,284,381,284,381Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.64,366.92c1.71,2,2.52,3,2.52,3l2.44-.8s-4.33-4.72-7.13-7.19a8.52,8.52,0,0,0-1.6-1.26c1.41-3.7,1.36-9.78,1.36-9.78a19.58,19.58,0,0,1-3.69,8.89,16.06,16.06,0,0,0-7-.08c-4.89.81-19.09,3.23-19.09,3.23s13.61-1.23,20.69-1.5S300.94,364.92,302.64,366.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M347.16,398.12c3.44,1.35,5.56,2.72,7.15,4.79s2.07,4.18.56,6.7-4.28,5.47-7.57,5.27a17.8,17.8,0,0,1-8.38-2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,401c0,1,4.3,3.08,8.81,5.23,4.84,2.31,6,3.81,10,5.76,4.51,2.22,6.23,2.34,9.73,1.37s7.82-6,4.81-10.59c-2.45-3.76-5.63-4.79-10.45-6.06a89.59,89.59,0,0,1-11.28-3.65c-3.49-1.35-6.36-3.78-7.07-2.94.49.25,4.14,2.49,3.45,3.11-.17.31-.69.21-1.59-.16a1.52,1.52,0,0,0-1.25-.06,2.39,2.39,0,0,0-.9,1.09,25.53,25.53,0,0,0-1.09,2.76c-.27.63-.16.27-.41.91a7,7,0,0,0-.75,2.47c0,.39.34.52.64.72a11.12,11.12,0,0,1,1,.65c.11.09.32.38.26.53s-.74.14-1,0-.7-.22-1-.34S320.47,401.4,319.67,401Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,411.27c.65.33,4.74,2.23,6,1.09s-1.89-3.21-1.89-3.21-.5-3.09,3.22-7.63c.65.5,3.34.47,3.31-1.11s-4.55-3.53-4.62-3.56c4.62,1.24,7.66,2.3,10,5.95,3,4.61-1.31,9.62-4.81,10.59s-5.22.85-9.73-1.37C338,411.79,337.31,411.5,336.91,411.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.49,408.84c1.71.57.53,2.13-2,1.62-3.75-.75-6.86-2.88-11-4.2-4.51-2.15-9.11-4.16-8.81-5.3.81.31,2.53,1,2.53,1l1.21.47c3.43,1.47,7.21,3.85,10.91,4.85C337.58,408.19,339.78,408.27,341.49,408.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,402.1c-1.57-.9-1.84-1.67-4.91-3.08s-8.24-4.42-11.45-6.29a39.18,39.18,0,0,1-3.47-2.58c.53-.6,2.48,0,4.43,1.19s3.15,2,5.09,3c3.76,2.26,8,3.78,10.2,5.17S345.59,403,344,402.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,401.69a.55.55,0,0,1-.09.14,13.64,13.64,0,0,0-2.93,7.56.45.45,0,0,1-.43.43.38.38,0,0,1-.34-.44,14.35,14.35,0,0,1,3.18-8.14.35.35,0,0,1,.55,0A.44.44,0,0,1,344.26,401.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23,399.47a.57.57,0,0,1-.08.13,18.61,18.61,0,0,0-3.63,8.93.44.44,0,0,1-.44.41.38.38,0,0,1-.33-.45,19.28,19.28,0,0,1,3.86-9.46.37.37,0,0,1,.55,0A.44.44,0,0,1,341.23,399.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.55,408.21a.44.44,0,0,1-.37.28.37.37,0,0,1-.37-.41c.18-5.48,3.71-10.62,3.87-10.8a.36.36,0,0,1,.55,0,.47.47,0,0,1,0,.6s-3.45,5.07-3.61,10.16A.8.8,0,0,1,334.55,408.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.74,406.42a.42.42,0,0,1-.35.27.37.37,0,0,1-.39-.39,16.16,16.16,0,0,1,4.09-10.25.36.36,0,0,1,.54,0,.46.46,0,0,1-.06.61,15.47,15.47,0,0,0-3.79,9.56A.37.37,0,0,1,331.74,406.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.11,404.89a.48.48,0,0,1-.35.27.37.37,0,0,1-.39-.39c0-5.7,4-10.11,4.21-10.29a.36.36,0,0,1,.55,0,.46.46,0,0,1-.06.6c0,.05-3.9,4.31-3.92,9.6A.65.65,0,0,1,328.11,404.89Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arms--inject-18",
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.21,286.84a4.39,4.39,0,0,0,.58-2.65c-.1-.6-1.37-1.07-1.37-1.07s.3-.78.39-1.05a6,6,0,0,0,.24-1.18.57.57,0,0,0-.31-.53c-.08,0-.34-.13-.43-.15-1.45-.33-2.47.79-3.27,1.82-2.09,2.69-3,5.2-5.35,7.66a9.19,9.19,0,0,1-3.2,2.36c-1,0-.13-3.68-1.24-6-.54-1.16-2.34-1.89-2.45-.12-.24,3.7-1.41,5.34-1.87,7.65s.14,4.07-3,6.93c-3,2.71-15.25,9.22-16.67,10,0,0-9.59-10.19-14.2-15-7.37-7.75-11.28-8.2-16.46-7.45-2.89,7,6,20.4,6,20.4s5.58,5.34,13.77,13.62c7.76,7.85,11.19,7.33,19.16,1,1-.76,2.05-1.62,3.14-2.54,6.79-5.6,8.18-7.74,10.65-9.92l0-.05c.83-.74,1.57-1.39,2.17-1.9,3.6-3,5.9-3.88,8.72-6.89a36.14,36.14,0,0,0,4.77-6.74c1.42-2.63.64-4.25.18-4.56C351.34,288.47,350.68,287.33,350.21,286.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.53,286.44c7.12-.3,10.58.66,16.54,6.54,3.87,3.81,12.15,12.87,12.15,12.87a28.89,28.89,0,0,1-6.16,7.19c-4.37,3.45-7.12,3.83-7.12,3.83s-7.5-7.8-9.26-9.73C283.48,304.73,276.78,292.12,279.53,286.44Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,293.1c1.06,2.16.23,5.91-3.15,8.19C339,300.49,341.17,295.73,338.53,293.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.22,316.3a7.34,7.34,0,0,1,3.81-7.08c.74.82,1.19,1.27,1.19,1.27A9,9,0,0,0,307.22,316.3Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.93,305.11c-1.22-13.54-5.86-18.09-12.77-18.58a138.21,138.21,0,0,0-15.1,1.48,59.46,59.46,0,0,0-16.57,6.42c-3.43,2.14-4.53,6.73-4.59,16.32a213,213,0,0,0,1.8,27.67,143.15,143.15,0,0,0,4.72,23.84c9.55,3.19,46.83-9.86,46.54-22-1-2.77-2.15-4.49-2.93-10.11C293,320.31,293.32,309.37,292.93,305.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.41,284c-.79-3.77-4.72-7.58-6.54-10.82s-2.83-5.55-2.76-8.55c0-1.78,1.06-4.23,2.36-4.78-1.78-6.54,3-9.37,5.2-10.23,1-.38,3.1-1,4.05-1.44,1.41-.65,1.69-1.81,2.8-2.83,1.92-1.76,5.26-1.93,6.63.57,1.25-1.76,3-1.78,5.13-1.34a3.54,3.54,0,0,1,2.86,3.89,3.7,3.7,0,0,1,5.63,1.81c.24,1.2,0,2.22.85,3.26s2.6,1.09,3.07.1c.35,1.69-.27,3-2.12,3a3.87,3.87,0,0,1,.61,3.23,3.52,3.52,0,0,1-3.1,2.56,6.19,6.19,0,0,1-.72,2.63,6.12,6.12,0,0,1-2.1,2c-2.75,1.45-5.82,2-8.81,2.74l-3.55.88c-.21.05-1.28.15-1.4.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.63,279.23a3.67,3.67,0,0,0,4.46-.3l.29,12.5c2.28,5.27,11.46,5.82,14.72,4.18s2.77-3.6.5-6.51l.15-2.05a36.51,36.51,0,0,0,4.5-.38c2.95-.52,5.1-3,5.82-6.27a33.29,33.29,0,0,0-.13-12.76,11.24,11.24,0,0,1-.28-3.11,14.7,14.7,0,0,0-1.18-6.66c-3.37-2.51-11-3.11-17.85,1.44,1,4.17-.53,7.56-3.52,9.27.19,1.13.44,4-1.43,4-1.34,0-1.49-1.66-2.93-3.09s-4.66-1.7-5.82.53A7.25,7.25,0,0,0,254.63,279.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,266l-8.22,3a3.55,3.55,0,0,1,1.34,1.39l7.28-2.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54,262.77H285a16.18,16.18,0,0,0-5.65,1.09c-1.73.86-2.26,1.61-3.27,1.77s-1.87-.38-3.91-.65a18.74,18.74,0,0,0-6.13.77l-.6.17a1,1,0,0,0-.54,1.16,2.34,2.34,0,0,0,.76,1.15,1.8,1.8,0,0,1,.27.48,22.58,22.58,0,0,0,1.22,3.37,4.3,4.3,0,0,0,1,1.14,2.47,2.47,0,0,0,.46.31l.25.13a3.39,3.39,0,0,0,.76.25l.12,0,.2,0,.2,0a4.37,4.37,0,0,0,.63,0l.27,0,.34,0a4.26,4.26,0,0,0,3.85-3.3c.42-1.42,0-3.25,1.13-3.42h.21c.9.07,1.08,1.79,1.83,2.93a5.2,5.2,0,0,0,1.07,1.23l.23.18.13.08.12.08.12.06.12.07.1,0,.07,0a3.7,3.7,0,0,0,1.1.28h.09a5.2,5.2,0,0,0,1.28-.07,3.51,3.51,0,0,0,3.15-3,22.56,22.56,0,0,0,0-3.57,1.05,1.05,0,0,1,.13-.48,2.4,2.4,0,0,0,.29-1.34C286.3,263.2,285.86,262.76,285.54,262.77Zm-11.23,6.73a4.13,4.13,0,0,1-.6,2h0a3.52,3.52,0,0,1-2.62,1.5,3,3,0,0,1-2.88-.94l-.1-.12-.1-.12a.76.76,0,0,1-.08-.11l-.07-.11-.06-.08,0-.07a.83.83,0,0,1-.07-.13h0c-.07-.13-.13-.25-.18-.37h0l-.09-.22c-.06-.13-.1-.25-.14-.36l0-.07,0-.06c-.32-.89-.8-2.65-.42-3.12a4.81,4.81,0,0,1,3.35-1.17h.21a8.42,8.42,0,0,1,.87,0l.35,0a7.47,7.47,0,0,1,.87.16l.28.07.29.09.06,0,.11.05a1.71,1.71,0,0,1,.64.38A4.41,4.41,0,0,1,274.31,269.5Zm10.94-2.12a3.92,3.92,0,0,1-1.24,3.24,3.52,3.52,0,0,1-4.44-.4h0l-.06-.08-.08-.09,0-.05-.09-.13-.11-.16-.05-.08s0,0,0,0a.25.25,0,0,1,0-.07l0-.05a4.15,4.15,0,0,1-.3-.66,4.61,4.61,0,0,1-.41-2.76,5,5,0,0,1,2.82-1.81,6.08,6.08,0,0,1,.85-.2l.1,0,.11,0,.3,0H283a3.2,3.2,0,0,1,.44,0h.21l.11,0,.13,0,.22.05h0a2.06,2.06,0,0,1,.51.23C285.14,264.63,285.26,266.44,285.25,267.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.65,273.17l-4.38,2.5-1.84-7c.08-.75.22-1.34.86-1.43h.22a.41.41,0,0,1,.16,0l.24.19a1.62,1.62,0,0,1,.2.18,13.3,13.3,0,0,1,1.43,1.51c.52.62,1.06,1.31,1.6,2,.24.31.47.63.7,1l.2.26C281.24,272.64,281.45,272.9,281.65,273.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75,287.05c-4.74-.38-8.34-.75-10.92-4.07a30.05,30.05,0,0,1-3.06-5.48,23.25,23.25,0,0,0,2.29,6.92c1.27,2.14,4.15,3.95,11.56,4.31Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,268.73a1.33,1.33,0,1,1-1.44-1.26A1.35,1.35,0,0,1,272.63,268.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,263.2l-2.91,1.43a1.7,1.7,0,0,1,.77-2.22A1.57,1.57,0,0,1,271.3,263.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.18,277.35l4.46,1.14a2.42,2.42,0,0,1-2.88,1.7A2.25,2.25,0,0,1,272.18,277.35Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,280.14a2.72,2.72,0,0,0-2.94-2.13,2.22,2.22,0,0,0,1.67,2.18A2.28,2.28,0,0,0,275,280.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.88,262.41l-3.26-.26a1.57,1.57,0,0,1,1.69-1.52A1.73,1.73,0,0,1,282.88,262.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,267.3a1.33,1.33,0,1,1-1.33-1.38A1.35,1.35,0,0,1,283.2,267.3Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.33,366.22v.89a2.5,2.5,0,0,0,1.25,2.19l24,14a2.49,2.49,0,0,0,1.27.34,2.38,2.38,0,0,0,1.26-.33L343.39,358a2.53,2.53,0,0,0,1.28-2.18v-.62l-46.81,26.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.67,355.17l-26.12-15.23a1.53,1.53,0,0,0-1.51,0L271.5,366a.33.33,0,0,0,0,.58l26.36,15.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.63 379.7 283.54 371.49 324.95 347.83 339.11 355.99 297.63 379.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.79 357.01 291.05 357.16 297.95 361.19 310.3 354.13 310.55 353.99 303.39 349.81 290.79 357.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.05 357.16 297.95 361.19 310.3 354.13 303.39 350.11 291.05 357.16",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.86,381.92v1.68a2.38,2.38,0,0,0,1.26-.33L343.39,358a2.53,2.53,0,0,0,1.28-2.18v-.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.86,381.92v1.68a2.38,2.38,0,0,0,1.26-.33L343.39,358a2.53,2.53,0,0,0,1.28-2.18v-.62Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.4,337.37c.61-11.79,1.25-22.47,2.61-31.15.75-4.8,5.14-9.4,9.74-11.27,6.78,3.69,6.47,17.36,6,20.72l-2.5,20.84s5.92,3.79,12.12,7.27c5.23,2.94,8.69,5.37,14.45,5.35s8-.48,11.14.44c1.66.5,5.45,1.65,6.75,2.12s3.77,2.42,6,3.67-.19,2.43-1.72,2.17a19,19,0,0,1-4.73-1.62,25.68,25.68,0,0,0-4-1,23.15,23.15,0,0,1,1.35,4.36c.11.82.41,1.79-.23,2.47a6.61,6.61,0,0,1-1.62.91,1.23,1.23,0,0,1-.25.83,2.05,2.05,0,0,1-1.4.55,5.48,5.48,0,0,1-.84,0,1.53,1.53,0,0,1-.78,1.29,6.65,6.65,0,0,1-3.47.54c-.18-.05-1.56-.59-2-.74a3.48,3.48,0,0,1-1.38-.65c-.33-.39.34-1.47,1-1.66a7,7,0,0,1,2.23-.12,7.55,7.55,0,0,1-.88-1.83c-.72-.9-5,.62-8.91.42-3-.15-5.43-2.67-6.82-3.1-8.87-2.77-15.61-4.64-24.73-8.73C235.21,345.71,236.08,343.49,236.4,337.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,355.08c-.58-1-1.43-2.28-2.31-2.48a10.35,10.35,0,0,1,1.53,2.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.73,362.66a9.75,9.75,0,0,0-.22-2.41,20.74,20.74,0,0,0-.6-2.35,10.3,10.3,0,0,0-.94-2.26,4.46,4.46,0,0,0-1.67-1.75,3.32,3.32,0,0,1,.77.9,6.92,6.92,0,0,1,.59,1,17.88,17.88,0,0,1,.81,2.23c.24.76.46,1.52.69,2.29A20.82,20.82,0,0,1,291.73,362.66Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,364a11.82,11.82,0,0,0-.29-2.37,19.91,19.91,0,0,0-.64-2.29,16.23,16.23,0,0,0-.92-2.2,4.51,4.51,0,0,0-1.46-1.88,3,3,0,0,1,.66,1c.17.35.33.7.47,1.07.29.72.56,1.46.81,2.2C288.38,361,288.86,362.48,289.24,364Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,362.8a4,4,0,0,1,1,0c.33,0,.57.17,1,.25l-.19-.24a.92.92,0,0,0,.12.46.91.91,0,0,0,.27.34,1.33,1.33,0,0,0,.71.35,3.35,3.35,0,0,1-.47-.55,2,2,0,0,1-.14-.3,1,1,0,0,1,0-.27v-.18l-.19-.06a3.06,3.06,0,0,0-.95-.08A2.07,2.07,0,0,0,282.65,362.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,294.25a16.62,16.62,0,0,0-10.1,12c-1.63,7.4-2.3,22.07-2.3,22.07s2.47,2.32,9,2.9,8.19-1,8.19-1,1.1-10.28,1.58-15S256.2,297.11,248.78,294.25Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,382.3a3,3,0,0,0,2.58-.19l44.08-25.19a3,3,0,0,0,1.47-2.09l4.94-28.68a4.22,4.22,0,0,0,0-.49,3,3,0,0,0-.88-2.13L305,349.71a2.23,2.23,0,0,0-1.08,1.54Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.57,382.3a3,3,0,0,0,2.58-.19l44.08-25.19a3,3,0,0,0,1.47-2.09l4.94-28.68a4.22,4.22,0,0,0,0-.49,3,3,0,0,0-.88-2.13L305,349.71a2.23,2.23,0,0,0-1.08,1.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.86,381.93l.3.17.41.2,5.34-31.05a2.23,2.23,0,0,1,1.08-1.54l45.81-26.18a2.61,2.61,0,0,0-.61-.47l-45.9,26.23a2.23,2.23,0,0,0-1.08,1.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,355.91c.33-1.92,2.33-4.47,4.46-5.69s3.59-.64,3.26,1.28-2.33,4.46-4.46,5.68S323.12,357.83,323.45,355.91Z",
    style: {
      fill: "#092166"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.38,242.87c-6.42.62-9.58,1.41-14.87,10.74L62.43,271.36s-14-4.29-17.51-6.34-2.09-3.27-3.62-7.76c-1.27-3.7-.41-5.51-1.38-6.51-.78-.81-2.8.32-2.49,5.21.25,4-1.52,3.18-2.49,2a17.44,17.44,0,0,1-2.18-4.74v-4.11a16.4,16.4,0,0,0-1.47,1.15,3.58,3.58,0,0,0-1.38,2.26c-.1.87.17,1.8-.2,2.6-.16.36-.45.66-.59,1-.37,1.06.61,2.16.49,3.28a10.37,10.37,0,0,1-.34,1.21,4.4,4.4,0,0,0,.49,2.76,21.48,21.48,0,0,0,4.8,7.16c.57.57,5.51,3.39,6.82,4.14,3.19,1.82,12,6.44,18.22,9.22,5.53,2.5,7.92,2.83,11.84-1.92,5-6.09,10.68-13.91,10.68-13.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.06,435.62c.58-.12.71,1.64.58,2.42s-2.25,3.57-6.44,4.93-10.19,1.22-12.74,1.39-6.29,1.83-8.74,2.63c-5.69,1.85-9.18.11-10.84-1.16a2.67,2.67,0,0,1-.86-2c-.13-1.69,0-2.05.18-2.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,436.27a33.43,33.43,0,0,0-.54,3.59c-.13,1.45-.21,3.3.88,4.33a8.05,8.05,0,0,0,6,2,18,18,0,0,0,7.35-1.62,16.62,16.62,0,0,1,6.25-1.93c2.64-.14,6.3-.07,8.89-.63a21.26,21.26,0,0,0,6.34-2.12,8.22,8.22,0,0,0,3.53-4,6,6,0,0,0-4-5.51,13.42,13.42,0,0,0-6.75-.61c-2.47.3-4.3.85-6.52.95a10.81,10.81,0,0,1-4.48-.55c-.68-.26-1.24-1.19-1.61-1.79s-.65-1.42-1.36-1.41c0,0-11.58,1.29-12.63,1.47s-.86,1.81-.81,2.68,0,.77,0,1.52a9.69,9.69,0,0,1-.36,2.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69,430.1a1.67,1.67,0,0,1,.52-.25c1-.27,1.87.63,2.38,1.35a6.18,6.18,0,0,1,.7,1.44,3.58,3.58,0,0,1,.27,2c0,.17-.14.37-.31.35s-.21-.21-.25-.36a7.42,7.42,0,0,0-1.06-2.55,2.86,2.86,0,0,0-.73-.89,3,3,0,0,0-1.07-.52c-.16,0-.83.05-.7-.27a.42.42,0,0,1,.12-.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,430.44a2,2,0,0,1,1.38.22,2.76,2.76,0,0,1,.94,1.24,4.18,4.18,0,0,1,.47,3.37c-.15.32-.44.2-.58-.07a5,5,0,0,1-.24-1,9,9,0,0,0-.88-2.16,3.55,3.55,0,0,0-.51-.77,1.45,1.45,0,0,0-.49-.36,1.4,1.4,0,0,0-.29-.09,2.62,2.62,0,0,0-.28,0c0-.14.14-.24.27-.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,430a1.9,1.9,0,0,1,.92.48,2.47,2.47,0,0,1,.5.84,9.76,9.76,0,0,1,.65,2.16,2.77,2.77,0,0,1-.19,1.56c-.1.19-.28.39-.48.32s-.24-.4-.28-.59c-.07-.35-.08-.72-.12-1.07a6.28,6.28,0,0,0-1.62-3.48c0-.05-.09-.1-.08-.17s.14-.12.24-.11A2.42,2.42,0,0,1,123.76,430Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.81,430c1-.13,3.33,1,4.73,4a18,18,0,0,1,1.27,7.05,10.17,10.17,0,0,0,5.38-3.33,6.14,6.14,0,0,0,1.22-2,6.3,6.3,0,0,0-1.61-4.67c-1.69-1.61-4.12-2.52-7.76-2.3-4.09.24-4.32,1.36-4.32,1.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.26,410.61s2.23,16.14,2.56,19.46c.15,1.41,3.27,3,7.59,2.54,3-.31,4.92-2.14,5.19-3.71s1.16-20.6,1.16-20.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.23,411.43l4.91-15.58,14.55,2.7s-8.87,16.81-10,18.34C67.75,419.41,60.23,411.43,60.23,411.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.54,416a11.87,11.87,0,0,0,.2,4.36c.2,1.44.41,2.86.52,4.32a17.57,17.57,0,0,0,.36,2.62,16.76,16.76,0,0,1,.13,3.17c0,1.11,0,2.22.06,3.33a6.13,6.13,0,0,1,0,1.42c-.12.46,7,4.56,9.91,6.14l.52.25a4.56,4.56,0,0,0,4.68-1.1A7.94,7.94,0,0,0,69,431.8s-.37,0-.29-2.8c0-2,0-4.05.21-6.05a13.17,13.17,0,0,1,.95-3.66c.44-1.07,1.27-2.2,1.23-3.39A5,5,0,0,0,70,413.54c-1-1.81-3.36-3.29-5.22-4.13-1.06-.47-2.79-1-3.88-.34-.59.36-.86,1.05-1.28,1.59a7.82,7.82,0,0,1-1.88,1.55,7.34,7.34,0,0,0-3,3.48C54.6,415.81,54.57,415.92,54.54,416Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,431.8a10.4,10.4,0,0,1,.93,1.34h0a10.07,10.07,0,0,1,1,7.41c5-.46,6.37-3.37,6.37-3.37s.28-2.52-2.62-4.35a6.07,6.07,0,0,0-1.1-.57l0,0A7.33,7.33,0,0,0,69,431.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36,416.83c-1.32.51-1,4.15-.14,7.66s1.29,4.73.87,7.65-.67,4.22.51,5.29,10.66,5.49,10.66,5.49a34.7,34.7,0,0,1-2.12-11c-.25-6.46-.68-10.62-3.68-13.56A5.68,5.68,0,0,0,53.36,416.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,437.17a17.66,17.66,0,0,1-7.9,3.45c-4.22.48-4.43-1.14-4.88-6.15s-.61-11.92-2.58-15-5.29-4.39-6.59-4.08c-.27-.14-1.56.82-2,1.41A7.23,7.23,0,0,1,58.89,419c2.64,2.58,3.12,8,3.24,13s.34,10.68,4.28,11.28A14.3,14.3,0,0,0,77.15,440,2,2,0,0,0,77.3,437.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,430a1.35,1.35,0,0,1,.58.91,2.82,2.82,0,0,1-1.43,2.6c-.53.3-1,.18-.13-.86A5.39,5.39,0,0,0,68.68,430Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.76,426.47a1.21,1.21,0,0,1,.36.76A4.38,4.38,0,0,1,67.38,430c-.92.41-.42-.61,0-1.09A18,18,0,0,0,68.76,426.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,422.64a.82.82,0,0,1,.44.62c0,.4-1.88,1.83-2.47,1.78s-.74-.23,0-.73S69,422.64,69,422.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,410.68s11.19-20.36,17.89-34.1c2.31-4.73,3.35-6.76,4-10.39S99,352.57,99,352.57l3.7,21.16a72.53,72.53,0,0,0-1.67,11.72c-.22,4.44.49,9.61,2.08,19.29,2.28,14,3.28,17.41,3.28,17.41,1,.75,3.56.9,6.14,1,6,.27,8.82-2.52,8.82-2.52s1.57-24.59,2.11-30.24c1.85-19.27,2-27.43,1.53-49.91-.38-19.17-2.45-42.23-2.45-42.23L80,288.06s-7.83,13.7-7,27.12c.86,14.58,1.34,46.72,1.34,46.72-2.31,3.77-4.37,7.61-6.54,16.83-1.27,5.41-3.75,17.12-5.5,25.69A13,13,0,0,1,73.66,410.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,352.57l-5.42-30s-5.83-.68-13.51-7.42c0,0,.51,5.26,10.73,9.76l5.84,26.63L95.6,366.19Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.76,199c5.46.19,10.6,3,12.84,8.42s-3.24,9-3.24,9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.47 235.55 105.71 251.31 91.18 250.14 92.29 233.01 106.47 235.55",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,217.64s3.76,5.51,3.36,6a7.37,7.37,0,0,1-2.34,1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.27,203.06c2.93.58,7,1.83,9,11.08.27,1.27-.16,3.2,0,4.78.22,1.78,1,3.75,1,5.17.2,7.43-1.95,10.29-3.23,11.51-1,1-6.37,1.33-9.15.48-3.49-1.06-11-4.73-14.57-10.43-4.16-6.7-5-15.64-.22-19.15C96.94,201.57,104.5,202.51,107.27,203.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83,235.79c-1.25.69-4.8,1-7.44.59l.08-2a20.16,20.16,0,0,0,3.52,1.15A12.18,12.18,0,0,0,113.83,235.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,201.48c-13.91-9.72-28.82-.26-29.11,13.13v.12c0,4.51-.24,9.36-.24,14.15,0,4.38.83,8.1,7.18,10.42,6,2.19,17.69,1.71,21,.28-3.1-1.17-3.45-4.7-3.45-10.18h0a10.5,10.5,0,0,0,.12-2.46c-3.54,3.26-7.49-2.6-5.93-6.59,1-2.38,4.85-1.94,5.86.15.49.65.89,1.53,1.74,1.78,1.74.4,1.27-1.74,1.43-2.78a7.09,7.09,0,0,0,3.75-5.17c.21,1,.81,2.12.13,2.89C118.55,211.83,116.54,205,111.28,201.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,249.13c1.22-4.22,4.69-5.9,8.07-6.26l4.29-.41c.82,1.44,10.59,1.95,14.43.69.93.17,3.41.78,6.8,1.74l1.3.71c4.9,1.6,8.72,3.78,12,17.72a12.85,12.85,0,0,1-4.41,13.38c.12,4-.77,6-.28,9.86,1.58,12.26,2.06,18.42,2.06,18.42S113,310.4,96.3,308.79c-10.29-1-20.08-6.69-22-8.55,0,0,1.75-6.45,7.17-17.37C79.81,269.06,76.77,257.91,79.31,249.13Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,244.89c8.61,2.46,10.6,2.61,17.15,10.13,6.18,7.09,15.13,16.5,15.13,16.5s25.45,1.06,27,.42,3.23-3.44,4.21-4.58a17.51,17.51,0,0,1,3-3c1-.65,1.86-1.34,2.74-2.07s1.91-1.55,2,.12a4.52,4.52,0,0,1-.65,2.61c-.3.5-.75.87-1.09,1.34a11,11,0,0,0-.87,1.53,1.43,1.43,0,0,0-.21,1,1,1,0,0,0,.65.65,2.49,2.49,0,0,0,.94.13,12.75,12.75,0,0,0,7.67-2.86c1.3-1,2.79-2.45,4.48-1.18a.39.39,0,0,0,.24.12.43.43,0,0,0,.21-.09,2.9,2.9,0,0,1,2.6-.38,1,1,0,0,1,.67.66c.2.78-.74,1.43-.76,2.21,0,.2.05.4.07.61a3.55,3.55,0,0,1-.66,2.34c-.44.7-1,1.31-1.5,2a3.7,3.7,0,0,0-.49.92c-.13.37-.16.78-.27,1.16a4.53,4.53,0,0,1-1.47,2,20.85,20.85,0,0,1-1.71,1.54c-1.47,1-3,2-4.57,2.91a8.17,8.17,0,0,1-3.29.84,31.8,31.8,0,0,1-3.64.25c-2.14.05-4.28-.13-6.41.13-2.46.3-29.77,5-33.94,2.71-3.82-2.08-14.12-9.72-21.38-15.26C105.64,256.87,112.9,244.89,112.9,244.89Z",
    style: {
      fill: "#ffa8a7"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDevelopment);
export default __webpack_public_path__ + "static/media/p_development.4261275befb782e4593cd945aa41c499.svg";
export { ForwardRef as ReactComponent };